const dataLiterature = {
    id3000: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Victor Hugo a écrit Les Misérables ?",
      answers: ["1869","1949","1865","1862"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3001: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Misérables en 1862 ?",
      answers: ["Léon Tolstoï","Victor Hugo","Charles Dickens","J.R.R. Tolkien"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3002: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Victor Hugo de 1862 ?",
      answers: ["La Route","Ne tirez pas sur l'oiseau moqueur","Les Mains sales","Les Misérables"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3003: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Léon Tolstoï a écrit Guerre et Paix ?",
      answers: ["1808","1883","1960","1865"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3004: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Guerre et Paix en 1865 ?",
      answers: ["Ray Bradbury","André Malraux","Léon Tolstoï","Jean-Paul Sartre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3005: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Léon Tolstoï de 1865 ?",
      answers: ["Guerre et Paix","Le Mur","Le Bruit et la Fureur","L'Idiot"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3006: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jane Austen a écrit Orgueil et Préjugés ?",
      answers: ["1943","1320","1813","1926"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3007: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Orgueil et Préjugés en 1813 ?",
      answers: ["Umberto Eco","Dante Alighieri","Jane Austen","Mary Shelley"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3008: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jane Austen de 1813 ?",
      answers: ["Bel-Ami","L'Appel de la forêt","Siddhartha","Orgueil et Préjugés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3009: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année George Orwell a écrit 1984 ?",
      answers: ["1949","1947","1847","1938"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3010: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit 1984 en 1949 ?",
      answers: ["George Orwell","Jules Verne","Ernest Hemingway","Primo Levi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3011: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de George Orwell de 1949 ?",
      answers: ["Le Seigneur des Anneaux","Fahrenheit 451","Le Bruit et la Fureur","1984"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3012: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Antoine de Saint-Exupéry a écrit Le Petit Prince ?",
      answers: ["1951","1808","1925","1943"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3013: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Petit Prince en 1943 ?",
      answers: ["Antoine de Saint-Exupéry","George Orwell","Robert Louis Stevenson","Ernest Hemingway"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3014: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Antoine de Saint-Exupéry de 1943 ?",
      answers: ["Vingt Mille Lieues sous les mers","Germinal","Le Tour du monde en quatre-vingts jours","Le Petit Prince"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3015: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Gabriel García Márquez a écrit Cent Ans de Solitude ?",
      answers: ["1862","1967","1774","1782"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3016: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Cent Ans de Solitude en 1967 ?",
      answers: ["Victor Hugo","Gabriel García Márquez","Patrick Süskind","Hermann Hesse"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3017: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Gabriel García Márquez de 1967 ?",
      answers: ["À la recherche du temps perdu","Cent Ans de Solitude","Orgueil et Préjugés","Chroniques martiennes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3018: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Albert Camus a écrit L'Étranger ?",
      answers: ["1960","1913","1942","1952"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3019: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Étranger en 1942 ?",
      answers: ["Miguel de Cervantes","Stendhal","Jonathan Swift","Albert Camus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3020: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Albert Camus de 1942 ?",
      answers: ["De la Terre à la Lune","L'Étranger","Les Misérables","L'Homme sans qualités"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3021: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Gustave Flaubert a écrit Madame Bovary ?",
      answers: ["1857","1865","1940","1897"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3022: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Madame Bovary en 1857 ?",
      answers: ["Margaret Mitchell","Boris Vian","Gustave Flaubert","Jack London"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3023: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Gustave Flaubert de 1857 ?",
      answers: ["Madame Bovary","Le Parfum","Le Rouge et le Noir","Le Bruit et la Fureur"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3024: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Alexandre Dumas a écrit Le Comte de Monte-Cristo ?",
      answers: ["1844","1925","1726","1932"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3025: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Comte de Monte-Cristo en 1844 ?",
      answers: ["Alexandre Dumas","Hermann Hesse","Victor Hugo","Léon Tolstoï"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3026: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Alexandre Dumas de 1844 ?",
      answers: ["Le Tambour","Madame Bovary","Le Comte de Monte-Cristo","Le Procès"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3027: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marcel Proust a écrit À la recherche du temps perdu ?",
      answers: ["1913","1880","1952","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3028: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit À la recherche du temps perdu en 1913 ?",
      answers: ["Ray Bradbury","Gabriel García Márquez","Robert Musil","Marcel Proust"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3029: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Marcel Proust de 1913 ?",
      answers: ["Notre-Dame de Paris","L'Idiot","L'Homme sans qualités","À la recherche du temps perdu"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3030: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ernest Hemingway a écrit Le Vieil Homme et la Mer ?",
      answers: ["1948","1844","1952","1940"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3031: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Vieil Homme et la Mer en 1952 ?",
      answers: ["Johann Wolfgang von Goethe","Hermann Hesse","Franz Kafka","Ernest Hemingway"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3032: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Ernest Hemingway de 1952 ?",
      answers: ["Les Fleurs du mal","De la Terre à la Lune","Le Vieil Homme et la Mer","Le Zéro et l'Infini"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3033: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Miguel de Cervantes a écrit Don Quichotte ?",
      answers: ["1985","1930","1605","1959"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3034: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Don Quichotte en 1605 ?",
      answers: ["William Faulkner","Miguel de Cervantes","Léon Tolstoï","Cormac McCarthy"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3035: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Miguel de Cervantes de 1605 ?",
      answers: ["L'Étranger","Le Pavillon d'or","Crime et Châtiment","Don Quichotte"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3036: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Fiodor Dostoïevski a écrit Crime et Châtiment ?",
      answers: ["1915","1869","1943","1866"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3037: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Crime et Châtiment en 1866 ?",
      answers: ["Victor Hugo","Jean-Paul Sartre","Fiodor Dostoïevski","Aldous Huxley"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3038: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Fiodor Dostoïevski de 1866 ?",
      answers: ["Crime et Châtiment","L'Homme qui rit","L'Être et le Néant","Le Magicien d'Oz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3039: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Herman Melville a écrit Moby Dick ?",
      answers: ["1925","1851","1948","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3040: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Moby Dick en 1851 ?",
      answers: ["Ernest Hemingway","Herman Melville","Jean-Jacques Rousseau","Ray Bradbury"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3041: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Herman Melville de 1851 ?",
      answers: ["Le Loup des steppes","Autant en emporte le vent","Moby Dick","Le Château"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3042: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Emily Brontë a écrit Les Hauts de Hurlevent ?",
      answers: ["1988","1847","1818","1890"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3043: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Hauts de Hurlevent en 1847 ?",
      answers: ["Alexandre Dumas","C.S. Lewis","Emily Brontë","Johann Wolfgang von Goethe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3044: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Emily Brontë de 1847 ?",
      answers: ["Tess d'Urberville","Le Grand Gatsby","Germinal","Les Hauts de Hurlevent"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3045: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Stendhal a écrit Le Rouge et le Noir ?",
      answers: ["1900","1830","1838","1831"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3046: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Rouge et le Noir en 1830 ?",
      answers: ["Stendhal","Albert Camus","William Golding","Robert Musil"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3047: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Stendhal de 1830 ?",
      answers: ["Du côté de chez Swann","Le Rouge et le Noir","Anna Karénine","Le Vieil Homme et la Mer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3048: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Léon Tolstoï a écrit Anna Karénine ?",
      answers: ["1877","1940","1980","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3049: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Anna Karénine en 1877 ?",
      answers: ["Patrick Süskind","Aldous Huxley","Léon Tolstoï","Hermann Hesse"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3050: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Léon Tolstoï de 1877 ?",
      answers: ["David Copperfield","Anna Karénine","Le Tambour","Tess d'Urberville"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3051: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année J.R.R. Tolkien a écrit Le Seigneur des Anneaux ?",
      answers: ["1948","1954","1830","1927"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3052: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Seigneur des Anneaux en 1954 ?",
      answers: ["Jules Verne","J.R.R. Tolkien","Jonathan Swift","John Steinbeck"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3053: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de J.R.R. Tolkien de 1954 ?",
      answers: ["Les Fleurs du mal","Les Enfants de minuit","Le Seigneur des Anneaux","L'Assommoir"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3054: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ray Bradbury a écrit Fahrenheit 451 ?",
      answers: ["1953","1719","1838","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3055: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Fahrenheit 451 en 1953 ?",
      answers: ["Fiodor Dostoïevski","William Golding","Ernest Hemingway","Ray Bradbury"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3056: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Ray Bradbury de 1953 ?",
      answers: ["Fahrenheit 451","Vingt Mille Lieues sous les mers","Du côté de chez Swann","Sa Majesté des mouches"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3057: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Robert Louis Stevenson a écrit L'Île au trésor ?",
      answers: ["1883","1930","1940","1925"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3058: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Île au trésor en 1883 ?",
      answers: ["Johann Wolfgang von Goethe","Émile Zola","Hermann Hesse","Robert Louis Stevenson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3059: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Robert Louis Stevenson de 1883 ?",
      answers: ["Thérèse Raquin","La Chute","1984","L'Île au trésor"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3060: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charles Baudelaire a écrit Les Fleurs du mal ?",
      answers: ["1956","1857","1831","1988"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3061: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Fleurs du mal en 1857 ?",
      answers: ["Charles Baudelaire","Ernest Hemingway","Fiodor Dostoïevski","Aldous Huxley"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3062: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Charles Baudelaire de 1857 ?",
      answers: ["L'Écume des jours","La Chute","Les Fleurs du mal","Candide"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3063: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Voltaire a écrit Candide ?",
      answers: ["1880","1950","1353","1759"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3064: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Candide en 1759 ?",
      answers: ["Voltaire","Jonathan Swift","André Malraux","Gustave Flaubert"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3065: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Voltaire de 1759 ?",
      answers: ["Fahrenheit 451","Le Pavillon d'or","Candide","À la recherche du temps perdu"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3066: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Aldous Huxley a écrit Le Meilleur des mondes ?",
      answers: ["1947","1929","1932","1951"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3067: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Meilleur des mondes en 1932 ?",
      answers: ["Albert Camus","Aldous Huxley","Ray Bradbury","William Faulkner"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3068: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Aldous Huxley de 1932 ?",
      answers: ["Le Meilleur des mondes","La Ferme des animaux","Jane Eyre","Le Petit Prince"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3069: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Mark Twain a écrit Les Aventures de Huckleberry Finn ?",
      answers: ["1948","1884","1951","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3070: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Aventures de Huckleberry Finn en 1884 ?",
      answers: ["Ernest Hemingway","John Steinbeck","Robert Louis Stevenson","Mark Twain"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3071: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Mark Twain de 1884 ?",
      answers: ["Bel-Ami","Le Mur","Le Grand Gatsby","Les Aventures de Huckleberry Finn"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3072: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Franz Kafka a écrit Le Procès ?",
      answers: ["1726","1925","1949","1950"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3073: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Procès en 1925 ?",
      answers: ["Marguerite Duras","Franz Kafka","Miguel de Cervantes","Jules Verne"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3074: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Franz Kafka de 1925 ?",
      answers: ["L'Alchimiste","Du côté de chez Swann","Fahrenheit 451","Le Procès"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3075: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charlotte Brontë a écrit Jane Eyre ?",
      answers: ["1953","1932","1929","1847"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3076: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Jane Eyre en 1847 ?",
      answers: ["Jean-Jacques Rousseau","Ernest Hemingway","Franz Kafka","Charlotte Brontë"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3077: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Charlotte Brontë de 1847 ?",
      answers: ["L'Homme sans qualités","Jane Eyre","Si c'est un homme","Guerre et Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3078: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Fiodor Dostoïevski a écrit Les Frères Karamazov ?",
      answers: ["1320","1885","1915","1880"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3079: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Frères Karamazov en 1880 ?",
      answers: ["Margaret Mitchell","Antoine de Saint-Exupéry","Jane Austen","Fiodor Dostoïevski"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3080: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Fiodor Dostoïevski de 1880 ?",
      answers: ["Faust","Les Frères Karamazov","L'Homme sans qualités","La Chute"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3081: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année J.D. Salinger a écrit L'Attrape-cœurs ?",
      answers: ["1900","1940","1951","1956"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3082: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Attrape-cœurs en 1951 ?",
      answers: ["J.D. Salinger","Jean-Paul Sartre","Ernest Hemingway","Yukio Mishima"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3083: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de J.D. Salinger de 1951 ?",
      answers: ["Le Soleil se lève aussi","Du côté de chez Swann","Des souris et des hommes","L'Attrape-cœurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3084: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Bram Stoker a écrit Dracula ?",
      answers: ["1726","1925","1897","1869"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3085: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Dracula en 1897 ?",
      answers: ["Ernest Hemingway","Aldous Huxley","Bram Stoker","Jean-Jacques Rousseau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3086: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Bram Stoker de 1897 ?",
      answers: ["Fahrenheit 451","Un chant de Noël","Dracula","Le Soleil se lève aussi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3087: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Oscar Wilde a écrit Le Portrait de Dorian Gray ?",
      answers: ["1940","1865","1719","1890"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3088: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Portrait de Dorian Gray en 1890 ?",
      answers: ["Oscar Wilde","Robert Musil","Émile Zola","Jules Verne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3089: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Oscar Wilde de 1890 ?",
      answers: ["Germinal","Le Portrait de Dorian Gray","Guerre et Paix","Le Bruit et la Fureur"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3090: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marcel Proust a écrit Du côté de chez Swann ?",
      answers: ["1913","1942","1932","1759"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3091: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Du côté de chez Swann en 1913 ?",
      answers: ["Marcel Proust","Robert Louis Stevenson","Pierre Choderlos de Laclos","Mary Shelley"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3092: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Marcel Proust de 1913 ?",
      answers: ["Du côté de chez Swann","Le Grand Gatsby","Les Frères Karamazov","Le Loup des steppes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3093: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Mary Shelley a écrit Frankenstein ?",
      answers: ["1925","1936","1984","1818"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3094: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Frankenstein en 1818 ?",
      answers: ["Cormac McCarthy","Jules Verne","Ernest Hemingway","Mary Shelley"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3095: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Mary Shelley de 1818 ?",
      answers: ["Frankenstein","Les Trois Mousquetaires","L'Idiot","Robinson Crusoé"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3096: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jonathan Swift a écrit Les Voyages de Gulliver ?",
      answers: ["1851","1726","1869","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3097: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Voyages de Gulliver en 1726 ?",
      answers: ["Marcel Proust","Albert Camus","Jonathan Swift","Hermann Hesse"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3098: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jonathan Swift de 1726 ?",
      answers: ["Le Bruit et la Fureur","Les Voyages de Gulliver","Le Nom de la rose","Le Zéro et l'Infini"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3099: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Umberto Eco a écrit Le Nom de la rose ?",
      answers: ["1774","1948","1869","1980"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3100: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Nom de la rose en 1980 ?",
      answers: ["Dante Alighieri","Giovanni Boccaccio","Jean-Jacques Rousseau","Umberto Eco"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3101: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Umberto Eco de 1980 ?",
      answers: ["Le Nom de la rose","La Condition humaine","Oliver Twist","Orgueil et Préjugés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3102: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Paulo Coelho a écrit L'Alchimiste ?",
      answers: ["1988","1884","1353","1866"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3103: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Alchimiste en 1988 ?",
      answers: ["Jean-Jacques Rousseau","Paulo Coelho","Jean-Paul Sartre","Johann Wolfgang von Goethe"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3104: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Paulo Coelho de 1988 ?",
      answers: ["Guerre et Paix","Pour qui sonne le glas","Les Trois Mousquetaires","L'Alchimiste"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3105: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ray Bradbury a écrit Chroniques martiennes ?",
      answers: ["1774","1843","1950","1940"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3106: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Chroniques martiennes en 1950 ?",
      answers: ["Ray Bradbury","Herman Melville","André Malraux","Léon Tolstoï"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3107: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Ray Bradbury de 1950 ?",
      answers: ["Chroniques martiennes","Le Portrait de Dorian Gray","Les Raisins de la colère","La Ferme des animaux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3108: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année F. Scott Fitzgerald a écrit Le Grand Gatsby ?",
      answers: ["1866","1862","1925","1927"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3109: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Grand Gatsby en 1925 ?",
      answers: ["Franz Kafka","J.R.R. Tolkien","F. Scott Fitzgerald","Charles Baudelaire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3110: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de F. Scott Fitzgerald de 1925 ?",
      answers: ["L'Étranger","Le Seigneur des Anneaux","Le Procès","Le Grand Gatsby"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3111: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Margaret Mitchell a écrit Autant en emporte le vent ?",
      answers: ["1808","1930","1936","1922"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3112: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Autant en emporte le vent en 1936 ?",
      answers: ["Marcel Proust","Margaret Mitchell","L. Frank Baum","Ernest Hemingway"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3113: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Margaret Mitchell de 1936 ?",
      answers: ["Les Misérables","Autant en emporte le vent","Des souris et des hommes","Le Décaméron"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3114: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Patrick Süskind a écrit Le Parfum ?",
      answers: ["1985","1932","1945","1844"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3115: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Parfum en 1985 ?",
      answers: ["Patrick Süskind","Gustave Flaubert","Ernest Hemingway","Jonathan Swift"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3116: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Patrick Süskind de 1985 ?",
      answers: ["Sa Majesté des mouches","La Chute","Le Portrait de Dorian Gray","Le Parfum"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3117: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Guy de Maupassant a écrit Bel-Ami ?",
      answers: ["1891","1954","1940","1885"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3118: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Bel-Ami en 1885 ?",
      answers: ["Alexandre Dumas","Günter Grass","Louis-Ferdinand Céline","Guy de Maupassant"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3119: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Guy de Maupassant de 1885 ?",
      answers: ["La Route","Bel-Ami","Les Souffrances du jeune Werther","Robinson Crusoé"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3120: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année John Steinbeck a écrit Les Raisins de la colère ?",
      answers: ["1891","1939","1967","1953"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3121: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Raisins de la colère en 1939 ?",
      answers: ["George Orwell","Albert Camus","C.S. Lewis","John Steinbeck"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3122: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de John Steinbeck de 1939 ?",
      answers: ["Les Souffrances du jeune Werther","Les Enfants de minuit","Les Raisins de la colère","Le Rouge et le Noir"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3123: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Fiodor Dostoïevski a écrit L'Idiot ?",
      answers: ["1880","1869","1857","1950"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3124: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Idiot en 1869 ?",
      answers: ["Miguel de Cervantes","Fiodor Dostoïevski","Margaret Mitchell","Daniel Defoe"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3125: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Fiodor Dostoïevski de 1869 ?",
      answers: ["L'Idiot","Fahrenheit 451","Les Mains sales","Le Seigneur des Anneaux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3126: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jack London a écrit L'Appel de la forêt ?",
      answers: ["1926","1932","1865","1903"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3127: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Appel de la forêt en 1903 ?",
      answers: ["Victor Hugo","Jack London","Pierre Choderlos de Laclos","J.D. Salinger"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3128: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jack London de 1903 ?",
      answers: ["Les Fleurs du mal","Le Meilleur des mondes","L'Appel de la forêt","Le Seigneur des Anneaux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3129: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Franz Kafka a écrit La Métamorphose ?",
      answers: ["1605","1880","1988","1915"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3130: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Métamorphose en 1915 ?",
      answers: ["Albert Camus","Jonathan Swift","Yukio Mishima","Franz Kafka"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3131: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Franz Kafka de 1915 ?",
      answers: ["Jane Eyre","Les Mains sales","La Métamorphose","La Route"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3132: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Alexandre Dumas a écrit Les Trois Mousquetaires ?",
      answers: ["1984","1844","1949","1869"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3133: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Trois Mousquetaires en 1844 ?",
      answers: ["Alexandre Dumas","Fiodor Dostoïevski","John Steinbeck","Marcel Proust"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3134: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Alexandre Dumas de 1844 ?",
      answers: ["Les Confessions","L'Alchimiste","Les Trois Mousquetaires","Le Grand Gatsby"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3135: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Thomas Hardy a écrit Tess d'Urberville ?",
      answers: ["1945","1897","1877","1891"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3136: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Tess d'Urberville en 1891 ?",
      answers: ["Thomas Hardy","William Golding","Ernest Hemingway","Mark Twain"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3137: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Thomas Hardy de 1891 ?",
      answers: ["Le Magicien d'Oz","Don Quichotte","Le Petit Prince","Tess d'Urberville"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3138: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Daniel Defoe a écrit Robinson Crusoé ?",
      answers: ["1951","1940","1719","1959"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3139: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Robinson Crusoé en 1719 ?",
      answers: ["Günter Grass","Daniel Defoe","Thomas Hardy","Jack London"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3140: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Daniel Defoe de 1719 ?",
      answers: ["Le Décaméron","Ne tirez pas sur l'oiseau moqueur","Robinson Crusoé","Les Liaisons dangereuses"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3141: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année J.R.R. Tolkien a écrit Le Hobbit ?",
      answers: ["1873","1943","1937","1782"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3142: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Hobbit en 1937 ?",
      answers: ["Antoine de Saint-Exupéry","John Steinbeck","J.R.R. Tolkien","Fiodor Dostoïevski"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3143: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de J.R.R. Tolkien de 1937 ?",
      answers: ["Le Hobbit","Les Aventures de Huckleberry Finn","L'Amant","Le Château"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3144: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Harper Lee a écrit Ne tirez pas sur l'oiseau moqueur ?",
      answers: ["1960","1913","1933","1880"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3145: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Ne tirez pas sur l'oiseau moqueur en 1960 ?",
      answers: ["Hermann Hesse","Oscar Wilde","Harper Lee","Daniel Defoe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3146: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Harper Lee de 1960 ?",
      answers: ["Anna Karénine","1984","L'Homme sans qualités","Ne tirez pas sur l'oiseau moqueur"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3147: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Franz Kafka a écrit Le Château ?",
      answers: ["1867","1926","1885","1980"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3148: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Château en 1926 ?",
      answers: ["Franz Kafka","William Golding","Thomas Hardy","Jean-Paul Sartre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3149: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Franz Kafka de 1926 ?",
      answers: ["Le Château","Le Vieil Homme et la Mer","Autant en emporte le vent","Le Soleil se lève aussi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3150: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Louis-Ferdinand Céline a écrit Voyage au bout de la nuit ?",
      answers: ["1926","1967","1857","1932"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3151: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Voyage au bout de la nuit en 1932 ?",
      answers: ["Voltaire","Ernest Hemingway","Stendhal","Louis-Ferdinand Céline"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3152: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Louis-Ferdinand Céline de 1932 ?",
      answers: ["Cent Ans de Solitude","Voyage au bout de la nuit","Le Petit Prince","Les Liaisons dangereuses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3153: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Albert Camus a écrit La Peste ?",
      answers: ["1808","1947","1922","1830"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3154: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Peste en 1947 ?",
      answers: ["Ernest Hemingway","Albert Camus","Aldous Huxley","Gustave Flaubert"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3155: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Albert Camus de 1947 ?",
      answers: ["Le Hobbit","Le Magicien d'Oz","Les Frères Karamazov","La Peste"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3156: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Boris Vian a écrit L'Écume des jours ?",
      answers: ["1885","1850","1891","1947"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3157: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Écume des jours en 1947 ?",
      answers: ["Léon Tolstoï","Guy de Maupassant","Alexandre Dumas","Boris Vian"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3158: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Boris Vian de 1947 ?",
      answers: ["Le Hobbit","Thérèse Raquin","L'Écume des jours","Sa Majesté des mouches"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3159: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pierre Choderlos de Laclos a écrit Les Liaisons dangereuses ?",
      answers: ["1936","1940","1782","1913"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3160: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Liaisons dangereuses en 1782 ?",
      answers: ["Pierre Choderlos de Laclos","Léon Tolstoï","Harper Lee","Oscar Wilde"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3161: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Pierre Choderlos de Laclos de 1782 ?",
      answers: ["Les Liaisons dangereuses","Madame Bovary","L'Amant","Cent Ans de Solitude"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3162: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année George Orwell a écrit La Ferme des animaux ?",
      answers: ["1950","1980","1945","1900"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3163: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Ferme des animaux en 1945 ?",
      answers: ["Ray Bradbury","Hermann Hesse","Jules Verne","George Orwell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3164: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de George Orwell de 1945 ?",
      answers: ["À la recherche du temps perdu","Le Château","La Ferme des animaux","Dracula"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3165: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Émile Zola a écrit Germinal ?",
      answers: ["1927","1885","1956","1915"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3166: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Germinal en 1885 ?",
      answers: ["Victor Hugo","Émile Zola","William Golding","Hermann Hesse"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3167: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Émile Zola de 1885 ?",
      answers: ["Germinal","Du côté de chez Swann","La Route","La Peste"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3168: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Malraux a écrit La Condition humaine ?",
      answers: ["1937","1954","1605","1933"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3169: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Condition humaine en 1933 ?",
      answers: ["Franz Kafka","Ernest Hemingway","Émile Zola","André Malraux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3170: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de André Malraux de 1933 ?",
      answers: ["David Copperfield","La Condition humaine","Le Vieil Homme et la Mer","Guerre et Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3171: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Dino Buzzati a écrit Le Désert des Tartares ?",
      answers: ["1869","1940","1984","1877"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3172: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Désert des Tartares en 1940 ?",
      answers: ["Umberto Eco","George Orwell","Stendhal","Dino Buzzati"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3173: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Dino Buzzati de 1940 ?",
      answers: ["Le Désert des Tartares","Les Fleurs du mal","Les Misérables","À la recherche du temps perdu"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3174: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Albert Camus a écrit La Chute ?",
      answers: ["1956","1945","1880","1948"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3175: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Chute en 1956 ?",
      answers: ["Jane Austen","John Steinbeck","Cormac McCarthy","Albert Camus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3176: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Albert Camus de 1956 ?",
      answers: ["Frankenstein","Notre-Dame de Paris","Le Meilleur des mondes","La Chute"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3177: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année L. Frank Baum a écrit Le Magicien d'Oz ?",
      answers: ["1925","1980","1900","1813"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3178: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Magicien d'Oz en 1900 ?",
      answers: ["Gustave Flaubert","Dino Buzzati","L. Frank Baum","George Orwell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3179: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de L. Frank Baum de 1900 ?",
      answers: ["Des souris et des hommes","Notre-Dame de Paris","Le Magicien d'Oz","Robinson Crusoé"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3180: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année C.S. Lewis a écrit Le Lion, la Sorcière blanche et l'Armoire magique ?",
      answers: ["1925","1950","1939","1844"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3181: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Lion, la Sorcière blanche et l'Armoire magique en 1950 ?",
      answers: ["Jean-Paul Sartre","C.S. Lewis","Franz Kafka","Fiodor Dostoïevski"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3182: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de C.S. Lewis de 1950 ?",
      answers: ["L'Île au trésor","Le Seigneur des Anneaux","Les Voyages de Gulliver","Le Lion, la Sorcière blanche et l'Armoire magique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3183: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charles Dickens a écrit Un chant de Noël ?",
      answers: ["1940","1605","1843","1719"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3184: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Un chant de Noël en 1843 ?",
      answers: ["Jean-Jacques Rousseau","Umberto Eco","Salman Rushdie","Charles Dickens"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3185: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Charles Dickens de 1843 ?",
      answers: ["Jane Eyre","Un chant de Noël","Le Désert des Tartares","Le Grand Gatsby"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3186: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charles Dickens a écrit Oliver Twist ?",
      answers: ["1877","1838","1850","1960"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3187: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Oliver Twist en 1838 ?",
      answers: ["Charles Dickens","J.R.R. Tolkien","Jean-Paul Sartre","Robert Louis Stevenson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3188: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Charles Dickens de 1838 ?",
      answers: ["Les Enfants de minuit","Oliver Twist","Le Château","L'Alchimiste"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3189: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charles Dickens a écrit David Copperfield ?",
      answers: ["1850","1980","1818","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3190: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit David Copperfield en 1850 ?",
      answers: ["Jean-Paul Sartre","Charles Dickens","Jack London","Jane Austen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3191: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Charles Dickens de 1850 ?",
      answers: ["Candide","David Copperfield","La Ferme des animaux","L'Idiot"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3192: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année William Faulkner a écrit Le Bruit et la Fureur ?",
      answers: ["1933","1956","1959","1929"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3193: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Bruit et la Fureur en 1929 ?",
      answers: ["Franz Kafka","Émile Zola","Umberto Eco","William Faulkner"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3194: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de William Faulkner de 1929 ?",
      answers: ["La Ferme des animaux","Les Souffrances du jeune Werther","Voyage au bout de la nuit","Le Bruit et la Fureur"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3195: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Émile Zola a écrit L'Assommoir ?",
      answers: ["1956","1877","1830","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3196: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Assommoir en 1877 ?",
      answers: ["Umberto Eco","Jean-Paul Sartre","Marguerite Duras","Émile Zola"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3197: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Émile Zola de 1877 ?",
      answers: ["L'Homme qui rit","Le Magicien d'Oz","L'Assommoir","Thérèse Raquin"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3198: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Émile Zola a écrit Thérèse Raquin ?",
      answers: ["1808","1959","1988","1867"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3199: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Thérèse Raquin en 1867 ?",
      answers: ["Ernest Hemingway","Marcel Proust","Émile Zola","Jean-Jacques Rousseau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3200: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Émile Zola de 1867 ?",
      answers: ["L'Être et le Néant","Les Trois Mousquetaires","Thérèse Raquin","Les Souffrances du jeune Werther"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3201: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Victor Hugo a écrit L'Homme qui rit ?",
      answers: ["1877","1869","1353","1942"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3202: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Homme qui rit en 1869 ?",
      answers: ["Charlotte Brontë","Victor Hugo","Robert Musil","George Orwell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3203: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Victor Hugo de 1869 ?",
      answers: ["L'Homme qui rit","Madame Bovary","Les Fleurs du mal","Le Magicien d'Oz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3204: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Victor Hugo a écrit Notre-Dame de Paris ?",
      answers: ["1951","1885","1937","1831"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3205: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Notre-Dame de Paris en 1831 ?",
      answers: ["Dino Buzzati","Victor Hugo","Oscar Wilde","Charles Baudelaire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3206: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Victor Hugo de 1831 ?",
      answers: ["Notre-Dame de Paris","Le Parfum","Les Trois Mousquetaires","Le Nom de la rose"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3207: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jules Verne a écrit Vingt Mille Lieues sous les mers ?",
      answers: ["1857","1865","1869","1870"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3208: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Vingt Mille Lieues sous les mers en 1870 ?",
      answers: ["Albert Camus","Robert Musil","Johann Wolfgang von Goethe","Jules Verne"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3209: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jules Verne de 1870 ?",
      answers: ["Autant en emporte le vent","Vingt Mille Lieues sous les mers","La Ferme des animaux","L'Étranger"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3210: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jules Verne a écrit Le Tour du monde en quatre-vingts jours ?",
      answers: ["1891","1866","1952","1873"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3211: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Tour du monde en quatre-vingts jours en 1873 ?",
      answers: ["Jules Verne","Gabriel García Márquez","Umberto Eco","Antoine de Saint-Exupéry"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3212: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jules Verne de 1873 ?",
      answers: ["Fahrenheit 451","Le Procès","Le Tour du monde en quatre-vingts jours","Le Tambour"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3213: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jules Verne a écrit De la Terre à la Lune ?",
      answers: ["1891","1984","1865","1953"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3214: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit De la Terre à la Lune en 1865 ?",
      answers: ["Margaret Mitchell","Charles Dickens","F. Scott Fitzgerald","Jules Verne"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3215: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jules Verne de 1865 ?",
      answers: ["Le Désert des Tartares","De la Terre à la Lune","Crime et Châtiment","Fahrenheit 451"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3216: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ernest Hemingway a écrit Le Soleil se lève aussi ?",
      answers: ["1926","1984","1913","1870"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3217: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Soleil se lève aussi en 1926 ?",
      answers: ["Arthur Koestler","Victor Hugo","Ernest Hemingway","Antoine de Saint-Exupéry"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3218: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Ernest Hemingway de 1926 ?",
      answers: ["Le Soleil se lève aussi","Le Magicien d'Oz","L'Étranger","L'Attrape-cœurs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3219: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ernest Hemingway a écrit Pour qui sonne le glas ?",
      answers: ["1940","1980","1943","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3220: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Pour qui sonne le glas en 1940 ?",
      answers: ["Jean-Paul Sartre","George Orwell","Ernest Hemingway","Dino Buzzati"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3221: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Ernest Hemingway de 1940 ?",
      answers: ["Pour qui sonne le glas","Les Confessions","Siddhartha","L'Étranger"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3222: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année John Steinbeck a écrit Des souris et des hommes ?",
      answers: ["1937","1981","1929","1847"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3223: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Des souris et des hommes en 1937 ?",
      answers: ["Charlotte Brontë","Voltaire","John Steinbeck","Johann Wolfgang von Goethe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3224: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de John Steinbeck de 1937 ?",
      answers: ["Don Quichotte","L'Appel de la forêt","Des souris et des hommes","Le Vieil Homme et la Mer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3225: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Yukio Mishima a écrit Le Pavillon d'or ?",
      answers: ["1830","1956","1884","1913"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3226: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Pavillon d'or en 1956 ?",
      answers: ["Alexandre Dumas","Margaret Mitchell","John Steinbeck","Yukio Mishima"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3227: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Yukio Mishima de 1956 ?",
      answers: ["Le Mur","Le Pavillon d'or","Les Voyages de Gulliver","Madame Bovary"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3228: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Hermann Hesse a écrit Siddhartha ?",
      answers: ["1782","1915","1953","1922"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3229: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Siddhartha en 1922 ?",
      answers: ["John Steinbeck","Robert Musil","Hermann Hesse","Boris Vian"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3230: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Hermann Hesse de 1922 ?",
      answers: ["Les Souffrances du jeune Werther","Siddhartha","Le Hobbit","Le Portrait de Dorian Gray"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3231: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Hermann Hesse a écrit Le Loup des steppes ?",
      answers: ["1942","1927","1926","1850"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3232: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Loup des steppes en 1927 ?",
      answers: ["Miguel de Cervantes","Marcel Proust","Hermann Hesse","Thomas Hardy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3233: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Hermann Hesse de 1927 ?",
      answers: ["Le Loup des steppes","Jane Eyre","Du contrat social","Les Mains sales"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3234: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Hermann Hesse a écrit Le Jeu des perles de verre ?",
      answers: ["1943","1938","1939","1865"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3235: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Jeu des perles de verre en 1943 ?",
      answers: ["Thomas Hardy","Hermann Hesse","Charles Dickens","Antoine de Saint-Exupéry"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3236: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Hermann Hesse de 1943 ?",
      answers: ["L'Attrape-cœurs","Le Tambour","Les Trois Mousquetaires","Le Jeu des perles de verre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3237: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Jacques Rousseau a écrit Les Confessions ?",
      answers: ["1949","1913","1885","1782"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3238: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Confessions en 1782 ?",
      answers: ["Jean-Jacques Rousseau","Marcel Proust","Jules Verne","Günter Grass"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3239: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Jacques Rousseau de 1782 ?",
      answers: ["L'Amant","Les Fleurs du mal","Les Confessions","Fahrenheit 451"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3240: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Jacques Rousseau a écrit Du contrat social ?",
      answers: ["1762","1943","1954","1932"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3241: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Du contrat social en 1762 ?",
      answers: ["Jean-Jacques Rousseau","J.D. Salinger","Alexandre Dumas","Émile Zola"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3242: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Jacques Rousseau de 1762 ?",
      answers: ["Du contrat social","1984","Les Trois Mousquetaires","La Condition humaine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3243: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Giovanni Boccaccio a écrit Le Décaméron ?",
      answers: ["1956","1926","1782","1353"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3244: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Décaméron en 1353 ?",
      answers: ["Albert Camus","Oscar Wilde","Giovanni Boccaccio","Boris Vian"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3245: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Giovanni Boccaccio de 1353 ?",
      answers: ["Le Nom de la rose","La Chute","Le Décaméron","L'Étranger"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3246: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Dante Alighieri a écrit La Divine Comédie ?",
      answers: ["1883","1865","1933","1320"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3247: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Divine Comédie en 1320 ?",
      answers: ["Dante Alighieri","Giovanni Boccaccio","Léon Tolstoï","Salman Rushdie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3248: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Dante Alighieri de 1320 ?",
      answers: ["Le Seigneur des Anneaux","La Divine Comédie","Les Frères Karamazov","Le Décaméron"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3249: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Johann Wolfgang von Goethe a écrit Les Souffrances du jeune Werther ?",
      answers: ["1929","1862","1774","1719"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3250: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Souffrances du jeune Werther en 1774 ?",
      answers: ["Charles Dickens","Victor Hugo","Salman Rushdie","Johann Wolfgang von Goethe"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3251: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Johann Wolfgang von Goethe de 1774 ?",
      answers: ["Cent Ans de Solitude","Le Lion, la Sorcière blanche et l'Armoire magique","Les Souffrances du jeune Werther","Des souris et des hommes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3252: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Johann Wolfgang von Goethe a écrit Faust ?",
      answers: ["1938","1808","1891","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3253: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Faust en 1808 ?",
      answers: ["Robert Louis Stevenson","Johann Wolfgang von Goethe","Émile Zola","Jean-Paul Sartre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3254: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Johann Wolfgang von Goethe de 1808 ?",
      answers: ["Un chant de Noël","Le Jeu des perles de verre","L'Écume des jours","Faust"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3255: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Günter Grass a écrit Le Tambour ?",
      answers: ["1959","1847","1885","1945"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3256: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Tambour en 1959 ?",
      answers: ["Charles Baudelaire","Salman Rushdie","Günter Grass","John Steinbeck"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3257: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Günter Grass de 1959 ?",
      answers: ["Le Meilleur des mondes","Le Rouge et le Noir","Jane Eyre","Le Tambour"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3258: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Robert Musil a écrit L'Homme sans qualités ?",
      answers: ["1930","1988","1838","1929"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3259: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Homme sans qualités en 1930 ?",
      answers: ["Robert Musil","J.R.R. Tolkien","Ernest Hemingway","Robert Louis Stevenson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3260: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Robert Musil de 1930 ?",
      answers: ["Si c'est un homme","L'Être et le Néant","L'Homme sans qualités","Un chant de Noël"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3261: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Salman Rushdie a écrit Les Enfants de minuit ?",
      answers: ["1913","1933","1981","1883"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3262: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Enfants de minuit en 1981 ?",
      answers: ["Jean-Paul Sartre","Jonathan Swift","Salman Rushdie","Franz Kafka"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3263: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Salman Rushdie de 1981 ?",
      answers: ["Chroniques martiennes","Les Frères Karamazov","À la recherche du temps perdu","Les Enfants de minuit"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3264: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marguerite Duras a écrit L'Amant ?",
      answers: ["1984","1850","1865","1869"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3265: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Amant en 1984 ?",
      answers: ["Marguerite Duras","Margaret Mitchell","Guy de Maupassant","Jules Verne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3266: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Marguerite Duras de 1984 ?",
      answers: ["L'Assommoir","L'Attrape-cœurs","L'Amant","Les Enfants de minuit"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3267: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Paul Sartre a écrit La Nausée ?",
      answers: ["1891","1938","1844","1943"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3268: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Nausée en 1938 ?",
      answers: ["Charles Dickens","Jean-Paul Sartre","Victor Hugo","Louis-Ferdinand Céline"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3269: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Paul Sartre de 1938 ?",
      answers: ["Les Raisins de la colère","La Nausée","Le Vieil Homme et la Mer","Jane Eyre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3270: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Paul Sartre a écrit Les Mains sales ?",
      answers: ["1353","1948","1866","1967"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3271: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Mains sales en 1948 ?",
      answers: ["Jean-Paul Sartre","Cormac McCarthy","Antoine de Saint-Exupéry","Émile Zola"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3272: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Paul Sartre de 1948 ?",
      answers: ["Les Mains sales","L'Être et le Néant","Le Petit Prince","Voyage au bout de la nuit"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3273: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Paul Sartre a écrit L'Être et le Néant ?",
      answers: ["1967","1985","1844","1943"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3274: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit L'Être et le Néant en 1943 ?",
      answers: ["Stendhal","Umberto Eco","Jean-Paul Sartre","Margaret Mitchell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3275: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Paul Sartre de 1943 ?",
      answers: ["L'Être et le Néant","L'Homme qui rit","Le Désert des Tartares","Cent Ans de Solitude"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3276: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Paul Sartre a écrit Le Mur ?",
      answers: ["1862","1867","1939","1847"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3277: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Mur en 1939 ?",
      answers: ["Fiodor Dostoïevski","Charles Dickens","Jean-Paul Sartre","Émile Zola"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3278: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Jean-Paul Sartre de 1939 ?",
      answers: ["Le Nom de la rose","Le Mur","Le Pavillon d'or","Vingt Mille Lieues sous les mers"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3279: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Arthur Koestler a écrit Le Zéro et l'Infini ?",
      answers: ["1774","1945","1940","1719"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3280: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Le Zéro et l'Infini en 1940 ?",
      answers: ["Arthur Koestler","Jane Austen","Jules Verne","Paulo Coelho"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3281: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Arthur Koestler de 1940 ?",
      answers: ["Du contrat social","Les Souffrances du jeune Werther","Le Zéro et l'Infini","L'Appel de la forêt"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3282: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Primo Levi a écrit Si c'est un homme ?",
      answers: ["1947","1719","1877","1353"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3283: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Si c'est un homme en 1947 ?",
      answers: ["Hermann Hesse","George Orwell","Margaret Mitchell","Primo Levi"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3284: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Primo Levi de 1947 ?",
      answers: ["Les Frères Karamazov","Des souris et des hommes","Si c'est un homme","Sa Majesté des mouches"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3285: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Cormac McCarthy a écrit La Route ?",
      answers: ["1877","2006","1981","1885"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3286: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit La Route en 2006 ?",
      answers: ["Umberto Eco","Ernest Hemingway","Cormac McCarthy","Fiodor Dostoïevski"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3287: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Cormac McCarthy de 2006 ?",
      answers: ["Les Mains sales","La Route","L'Écume des jours","L'Amant"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3288: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année William Golding a écrit Sa Majesté des mouches ?",
      answers: ["1940","1988","1862","1954"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3289: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Sa Majesté des mouches en 1954 ?",
      answers: ["William Golding","Ernest Hemingway","J.R.R. Tolkien","Jonathan Swift"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3290: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de William Golding de 1954 ?",
      answers: ["Crime et Châtiment","Les Misérables","Sa Majesté des mouches","La Condition humaine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3291: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Salman Rushdie a écrit Les Versets sataniques ?",
      answers: ["1988","1939","1844","1851"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3292: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Qui a écrit Les Versets sataniques en 1988 ?",
      answers: ["Daniel Defoe","André Malraux","Harper Lee","Salman Rushdie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3293: {
      themes: ["Littérature et Langues","Littérature","Divers"],
      question: "Comment s'appelle le livre de Salman Rushdie de 1988 ?",
      answers: ["Les Versets sataniques","Le Décaméron","Le Mur","Le Lion, la Sorcière blanche et l'Armoire magique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3400: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année John-Antoine Nau a-t-il remporté le Prix Goncourt pour Force ennemie ?",
      answers: ["1903","1909","1906","1905"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3401: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1903 pour Force ennemie ?",
      answers: ["Léon Frapié","Claude Farrère","Atiq Rahimi","John-Antoine Nau"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3402: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à John-Antoine Nau de remporter le Prix Goncourt en 1903 ?",
      answers: ["Force ennemie","Écrit sur de l’eau","Les Civilisés","Terres lorraines"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3403: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Léon Frapié a-t-il remporté le Prix Goncourt pour La Maternelle ?",
      answers: ["1903","1916","1908","1904"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3404: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1904 pour La Maternelle ?",
      answers: ["Léon Frapié","Jérôme et Jean Tharaud","André Pieyre de Mandiargues","Claude Farrère"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3405: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Léon Frapié de remporter le Prix Goncourt en 1904 ?",
      answers: ["Dingley, l’illustre écrivain","Alabama Song","La Maternelle","Force ennemie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3406: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Claude Farrère a-t-il remporté le Prix Goncourt pour Les Civilisés ?",
      answers: ["1936","2022","1903","1905"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3407: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1905 pour Les Civilisés ?",
      answers: ["John-Antoine Nau","Claude Farrère","Jérôme et Jean Tharaud","Jean Echenoz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3408: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Claude Farrère de remporter le Prix Goncourt en 1905 ?",
      answers: ["Faux passeports","Force ennemie","L’Ordre du jour","Les Civilisés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3409: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jérôme et Jean Tharaud a-t-il remporté le Prix Goncourt pour Dingley, l’illustre écrivain ?",
      answers: ["1907","1906","1925","1955"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3410: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1906 pour Dingley, l’illustre écrivain ?",
      answers: ["Claude Farrère","René Maran","John-Antoine Nau","Jérôme et Jean Tharaud"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3411: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jérôme et Jean Tharaud de remporter le Prix Goncourt en 1906 ?",
      answers: ["Les Civilisés","Terres lorraines","Dingley, l’illustre écrivain","De Goupil à Margot"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3412: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Émile Moselly a-t-il remporté le Prix Goncourt pour Terres lorraines ?",
      answers: ["1908","1905","1906","1907"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3413: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1907 pour Terres lorraines ?",
      answers: ["Marius-Ary Leblond","André Pieyre de Mandiargues","Roger Vercel","Émile Moselly"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3414: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Émile Moselly de remporter le Prix Goncourt en 1907 ?",
      answers: ["Mal d’amour","Terres lorraines","Dingley, l’illustre écrivain","L’Exposition coloniale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3415: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Francis de Miomandre a-t-il remporté le Prix Goncourt pour Écrit sur de l’eau ?",
      answers: ["1933","1905","1982","1908"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3416: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1908 pour Écrit sur de l’eau ?",
      answers: ["Henri Barbusse","Marius-Ary Leblond","André Savignon","Francis de Miomandre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3417: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Francis de Miomandre de remporter le Prix Goncourt en 1908 ?",
      answers: ["La Maternelle","Écrit sur de l’eau","Le Vitriol de Lune","Sang et Lumières"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3418: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marius-Ary Leblond a-t-il remporté le Prix Goncourt pour En France ?",
      answers: ["1910","1916","1907","1909"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3419: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1909 pour En France ?",
      answers: ["Marius-Ary Leblond","Julien Gracq","Claude Farrère","André Pieyre de Mandiargues"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3420: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marius-Ary Leblond de remporter le Prix Goncourt en 1909 ?",
      answers: ["Filles de la pluie","Batouala","Terres lorraines","En France"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3421: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Louis Pergaud a-t-il remporté le Prix Goncourt pour De Goupil à Margot ?",
      answers: ["1910","1922","1909","1933"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3422: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1910 pour De Goupil à Margot ?",
      answers: ["Henri Béraud","Maurice Bedel","Henri Deberly","Louis Pergaud"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3423: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Louis Pergaud de remporter le Prix Goncourt en 1910 ?",
      answers: ["Filles de la pluie","De Goupil à Margot","Monsieur des Lourdines","Dingley, l’illustre écrivain"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3424: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Alphonse de Châteaubriant a-t-il remporté le Prix Goncourt pour Monsieur des Lourdines ?",
      answers: ["1962","1911","2020","1908"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3425: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1911 pour Monsieur des Lourdines ?",
      answers: ["Ernest Pérochon","Alphonse de Châteaubriant","Claude Farrère","André Savignon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3426: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Alphonse de Châteaubriant de remporter le Prix Goncourt en 1911 ?",
      answers: ["Les Grandes Familles","Dingley, l’illustre écrivain","Écrit sur de l’eau","Monsieur des Lourdines"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3427: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Savignon a-t-il remporté le Prix Goncourt pour Filles de la pluie ?",
      answers: ["1920","1912","1951","1923"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3428: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1912 pour Filles de la pluie ?",
      answers: ["Francis de Miomandre","Roger Ikor","Romain Gary","André Savignon"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3429: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à André Savignon de remporter le Prix Goncourt en 1912 ?",
      answers: ["Rabevel ou le Mal des ardents","Le Feu","Terres lorraines","Filles de la pluie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3430: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marc Elder a-t-il remporté le Prix Goncourt pour Le Peuple de la mer ?",
      answers: ["1920","1976","1913","2005"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3431: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1913 pour Le Peuple de la mer ?",
      answers: ["Henri Fauconnier","André Savignon","Marc Elder","Alphonse de Châteaubriant"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3432: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marc Elder de remporter le Prix Goncourt en 1913 ?",
      answers: ["Le Peuple de la mer","Force ennemie","De Goupil à Margot","À l’ombre des jeunes filles en fleurs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3433: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Barbusse a-t-il remporté le Prix Goncourt pour Le Feu ?",
      answers: ["1921","1916","1913","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3434: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1916 pour Le Feu ?",
      answers: ["Maurice Genevoix","Henri Barbusse","Lydie Salvayre","Henri Béraud"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3435: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Barbusse de remporter le Prix Goncourt en 1916 ?",
      answers: ["Les Civilisés","Le Feu","Terres lorraines","De Goupil à Margot"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3436: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marcel Proust a-t-il remporté le Prix Goncourt pour À l’ombre des jeunes filles en fleurs ?",
      answers: ["1906","1919","1921","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3437: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1919 pour À l’ombre des jeunes filles en fleurs ?",
      answers: ["Jean Fayard","Henri Béraud","Marcel Proust","Lucien Fabre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3438: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marcel Proust de remporter le Prix Goncourt en 1919 ?",
      answers: ["Force ennemie","Le premier accroc coûte deux cents francs","À l’ombre des jeunes filles en fleurs","Le Feu"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3439: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Ernest Pérochon a-t-il remporté le Prix Goncourt pour Nêne ?",
      answers: ["1920","1916","1919","1922"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3440: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1920 pour Nêne ?",
      answers: ["Armand Lanoux","Léon Frapié","Ernest Pérochon","Marcel Proust"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3441: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Ernest Pérochon de remporter le Prix Goncourt en 1920 ?",
      answers: ["L’Araigne","Les Loups","L’Exposition coloniale","Nêne"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3442: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année René Maran a-t-il remporté le Prix Goncourt pour Batouala ?",
      answers: ["1965","1925","1921","1930"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3443: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1921 pour Batouala ?",
      answers: ["René Maran","Marc Elder","André Savignon","Henri Béraud"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3444: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à René Maran de remporter le Prix Goncourt en 1921 ?",
      answers: ["Le Chèvrefeuille","Mal d’amour","Rabevel ou le Mal des ardents","Batouala"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3445: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Béraud a-t-il remporté le Prix Goncourt pour Le Vitriol de Lune ?",
      answers: ["1922","1985","1924","1925"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3446: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1922 pour Le Vitriol de Lune ?",
      answers: ["Thierry Sandre","Lucien Fabre","Henri Béraud","Marcel Proust"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3447: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Béraud de remporter le Prix Goncourt en 1922 ?",
      answers: ["La Vie devant soi","Les Forêts de la nuit","Le Vitriol de Lune","Vent de Mars"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3448: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Lucien Fabre a-t-il remporté le Prix Goncourt pour Rabevel ou le Mal des ardents ?",
      answers: ["1920","1923","1997","1922"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3449: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1923 pour Rabevel ou le Mal des ardents ?",
      answers: ["Lucien Fabre","Henri Béraud","Thierry Sandre","Jean-Louis Curtis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3450: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Lucien Fabre de remporter le Prix Goncourt en 1923 ?",
      answers: ["Rabevel ou le Mal des ardents","Nêne","Les Civilisés","Le Dernier des Justes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3451: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Thierry Sandre a-t-il remporté le Prix Goncourt pour Le Chèvrefeuille ?",
      answers: ["1934","1924","1916","1926"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3452: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1924 pour Le Chèvrefeuille ?",
      answers: ["Constantin-Weyer","Thierry Sandre","Charles Plisnier","Jean-Jacques Gautier"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3453: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Thierry Sandre de remporter le Prix Goncourt en 1924 ?",
      answers: ["L’Ordre","Le Chèvrefeuille","Le Testament français","Terres lorraines"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3454: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Maurice Genevoix a-t-il remporté le Prix Goncourt pour Raboliot ?",
      answers: ["1924","1925","1926","1910"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3455: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1925 pour Raboliot ?",
      answers: ["Pierre Gascar","Henri Deberly","Maurice Genevoix","Thierry Sandre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3456: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Maurice Genevoix de remporter le Prix Goncourt en 1925 ?",
      answers: ["En France","Le Vitriol de Lune","Raboliot","Batouala"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3457: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Deberly a-t-il remporté le Prix Goncourt pour Le Supplice de Phèdre ?",
      answers: ["1927","1905","1926","1910"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3458: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1926 pour Le Supplice de Phèdre ?",
      answers: ["Henri Deberly","Ernest Pérochon","Constantin-Weyer","Thierry Sandre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3459: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Deberly de remporter le Prix Goncourt en 1926 ?",
      answers: ["Le Supplice de Phèdre","La Condition humaine","Le Feu","Le Chèvrefeuille"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3460: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Maurice Bedel a-t-il remporté le Prix Goncourt pour Jérôme 60° latitude nord ?",
      answers: ["1926","1927","1928","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3461: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1927 pour Jérôme 60° latitude nord ?",
      answers: ["Maurice Bedel","Félicien Marceau","Henri Troyat","Pascal Lainé"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3462: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Maurice Bedel de remporter le Prix Goncourt en 1927 ?",
      answers: ["Jérôme 60° latitude nord","Les Jeux sauvages","Les Champs d’honneur","Le Supplice de Phèdre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3463: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Constantin-Weyer a-t-il remporté le Prix Goncourt pour Un homme se penche sur son passé ?",
      answers: ["1907","1912","1928","1925"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3464: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1928 pour Un homme se penche sur son passé ?",
      answers: ["Maurice Bedel","André Savignon","John-Antoine Nau","Constantin-Weyer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3465: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Constantin-Weyer de remporter le Prix Goncourt en 1928 ?",
      answers: ["À l’ombre des jeunes filles en fleurs","Jérôme 60° latitude nord","Le Vitriol de Lune","Un homme se penche sur son passé"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3466: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marcel Arland a-t-il remporté le Prix Goncourt pour L’Ordre ?",
      answers: ["1939","1929","2009","1949"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3467: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1929 pour L’Ordre ?",
      answers: ["Thierry Sandre","Guy Mazeline","René Maran","Marcel Arland"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3468: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marcel Arland de remporter le Prix Goncourt en 1929 ?",
      answers: ["Pareils à des enfants","Le Supplice de Phèdre","Les Loups","L’Ordre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3469: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Fauconnier a-t-il remporté le Prix Goncourt pour Malaisie ?",
      answers: ["1930","1928","1957","1926"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3470: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1930 pour Malaisie ?",
      answers: ["Henri Fauconnier","Constantin-Weyer","Brigitte Giraud","Frédéric Tristan"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3471: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Fauconnier de remporter le Prix Goncourt en 1930 ?",
      answers: ["Les Jeux sauvages","Un homme se penche sur son passé","Malaisie","L’Ordre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3472: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Fayard a-t-il remporté le Prix Goncourt pour Mal d’amour ?",
      answers: ["1928","1931","1919","1945"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3473: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1931 pour Mal d’amour ?",
      answers: ["Jean Fayard","Guy Mazeline","Jacques-Pierre Amette","Jean-Louis Curtis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3474: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Fayard de remporter le Prix Goncourt en 1931 ?",
      answers: ["Léon Morin, prêtre","L’Ordre","Mal d’amour","De Goupil à Margot"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3475: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Guy Mazeline a-t-il remporté le Prix Goncourt pour Les Loups ?",
      answers: ["1931","1932","1941","1929"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3476: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1932 pour Les Loups ?",
      answers: ["Guy Mazeline","Henri Barbusse","Maurice Bedel","Marius Grout"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3477: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Guy Mazeline de remporter le Prix Goncourt en 1932 ?",
      answers: ["Raboliot","En France","Le Chèvrefeuille","Les Loups"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3478: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Malraux a-t-il remporté le Prix Goncourt pour La Condition humaine ?",
      answers: ["1933","1916","1947","1928"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3479: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1933 pour La Condition humaine ?",
      answers: ["Pascal Quignard","Thierry Sandre","André Malraux","Jean Rouaud"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3480: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à André Malraux de remporter le Prix Goncourt en 1933 ?",
      answers: ["Batouala","La Condition humaine","Mal d’amour","Les Forêts de la nuit"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3481: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Roger Vercel a-t-il remporté le Prix Goncourt pour Capitaine Conan ?",
      answers: ["1920","1935","1922","1934"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3482: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1934 pour Capitaine Conan ?",
      answers: ["Marcel Arland","Henri Fauconnier","Antonine Maillet","Roger Vercel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3483: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Roger Vercel de remporter le Prix Goncourt en 1934 ?",
      answers: ["Les Loups","Capitaine Conan","La Condition humaine","L’Épervier de Maheux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3484: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Joseph Peyré a-t-il remporté le Prix Goncourt pour Sang et Lumières ?",
      answers: ["1953","2022","1935","1929"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3485: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1935 pour Sang et Lumières ?",
      answers: ["Joseph Peyré","Roger Vercel","Louis Pergaud","Francis Carco"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3486: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Joseph Peyré de remporter le Prix Goncourt en 1935 ?",
      answers: ["Sang et Lumières","La Dentellière","Les Bêtises","Jérôme 60° latitude nord"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3487: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Maxence Van der Meersch a-t-il remporté le Prix Goncourt pour L’Empreinte du dieu ?",
      answers: ["1937","1936","1935","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3488: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1936 pour L’Empreinte du dieu ?",
      answers: ["Guy Mazeline","Maxence Van der Meersch","John-Antoine Nau","Marius Grout"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3489: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Maxence Van der Meersch de remporter le Prix Goncourt en 1936 ?",
      answers: ["Faux passeports","Les Loups","L’Empreinte du dieu","Les Enfants gâtés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3490: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Charles Plisnier a-t-il remporté le Prix Goncourt pour Faux passeports ?",
      answers: ["1940","1937","2008","2000"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3491: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1937 pour Faux passeports ?",
      answers: ["André Malraux","Maxence Van der Meersch","Francis Ambrière","Charles Plisnier"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3492: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Charles Plisnier de remporter le Prix Goncourt en 1937 ?",
      answers: ["Faux passeports","Le Peuple de la mer","L’Ogre","L’Ordre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3493: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Troyat a-t-il remporté le Prix Goncourt pour L’Araigne ?",
      answers: ["1936","1944","1938","1957"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3494: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1938 pour L’Araigne ?",
      answers: ["Maurice Genevoix","Jean Fayard","Maxence Van der Meersch","Henri Troyat"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3495: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Troyat de remporter le Prix Goncourt en 1938 ?",
      answers: ["Vent de Mars","Les Flamboyants","L’Araigne","La Pitié de Dieu"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3496: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Philippe Hériat a-t-il remporté le Prix Goncourt pour Les Enfants gâtés ?",
      answers: ["1941","1940","1939","2003"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3497: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1939 pour Les Enfants gâtés ?",
      answers: ["Jean Fayard","Philippe Hériat","André Pieyre de Mandiargues","Jean-Louis Curtis"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3498: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Philippe Hériat de remporter le Prix Goncourt en 1939 ?",
      answers: ["Les Enfants gâtés","Malaisie","Les Grandes Vacances","Chasseur zéro"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3499: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Francis Ambrière a-t-il remporté le Prix Goncourt pour Les Grandes Vacances ?",
      answers: ["1940","1956","1941","1933"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3500: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1940 pour Les Grandes Vacances ?",
      answers: ["Francis Carco","André Savignon","Henri Troyat","Francis Ambrière"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3501: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Francis Ambrière de remporter le Prix Goncourt en 1940 ?",
      answers: ["Les Loups","Sang et Lumières","Les Grandes Vacances","Vent de Mars"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3502: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Henri Pourrat a-t-il remporté le Prix Goncourt pour Vent de Mars ?",
      answers: ["1932","1993","1941","1938"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3503: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1941 pour Vent de Mars ?",
      answers: ["Paul Colin","Henri Pourrat","Francis Ambrière","Guy Mazeline"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3504: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Henri Pourrat de remporter le Prix Goncourt en 1941 ?",
      answers: ["Pareils à des enfants","Les Loups","L’Araigne","Vent de Mars"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3505: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marc Bernard a-t-il remporté le Prix Goncourt pour Pareils à des enfants ?",
      answers: ["1942","1941","1945","1963"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3506: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1942 pour Pareils à des enfants ?",
      answers: ["Roger Ikor","Jacques-Pierre Amette","Marc Bernard","Marius Grout"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3507: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marc Bernard de remporter le Prix Goncourt en 1942 ?",
      answers: ["Malaisie","Léon Morin, prêtre","Pareils à des enfants","Les Bêtises"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3508: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marius Grout a-t-il remporté le Prix Goncourt pour Passage de l’homme ?",
      answers: ["1944","2009","1941","1943"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3509: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1943 pour Passage de l’homme ?",
      answers: ["Marius Grout","Simone de Beauvoir","Edmonde Charles-Roux","Henri Pourrat"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3510: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marius Grout de remporter le Prix Goncourt en 1943 ?",
      answers: ["Les Forêts de la nuit","Passage de l’homme","Le Jardin d’acclimatation","Vivre vite"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3511: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Elsa Triolet a-t-elle remportée le Prix Goncourt pour Le premier accroc coûte deux cents francs ?",
      answers: ["1946","1956","1951","1944"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3512: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1944 pour Le premier accroc coûte deux cents francs ?",
      answers: ["Henri Pourrat","Patrick Modiano","Elsa Triolet","Roger Ikor"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3513: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Elsa Triolet de remporter le Prix Goncourt en 1944 ?",
      answers: ["Mon village à l’heure allemande","La Motocyclette","Les Grandes Vacances","Le premier accroc coûte deux cents francs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3514: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Louis Bory a-t-il remporté le Prix Goncourt pour Mon village à l’heure allemande ?",
      answers: ["2003","1939","1945","1944"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3515: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1945 pour Mon village à l’heure allemande ?",
      answers: ["Charles Plisnier","Jean-Louis Bory","Émile Moselly","Maurice Druon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3516: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Louis Bory de remporter le Prix Goncourt en 1945 ?",
      answers: ["Mon village à l’heure allemande","Rue des Boutiques Obscures","L’Empreinte du dieu","Pareils à des enfants"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3517: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Jacques Gautier a-t-il remporté le Prix Goncourt pour Histoire d’un fait divers ?",
      answers: ["1963","1967","1946","1944"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3518: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1946 pour Histoire d’un fait divers ?",
      answers: ["Jean-Jacques Gautier","Elsa Triolet","Dominique Fernandez","Michel Host"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3519: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Jacques Gautier de remporter le Prix Goncourt en 1946 ?",
      answers: ["Les Enfants gâtés","Le premier accroc coûte deux cents francs","Histoire d’un fait divers","Le Rivage des Syrtes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3520: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Louis Curtis a-t-il remporté le Prix Goncourt pour Les Forêts de la nuit ?",
      answers: ["1942","1947","1952","1946"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3521: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1947 pour Les Forêts de la nuit ?",
      answers: ["Jean-Louis Curtis","Jean-Louis Bory","Jean-Jacques Gautier","Robert Merle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3522: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Louis Curtis de remporter le Prix Goncourt en 1947 ?",
      answers: ["Le premier accroc coûte deux cents francs","Les Forêts de la nuit","Les Jeux sauvages","Le Rivage des Syrtes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3523: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Maurice Druon a-t-il remporté le Prix Goncourt pour Les Grandes Familles ?",
      answers: ["1976","1962","1953","1948"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3524: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1948 pour Les Grandes Familles ?",
      answers: ["Jean Rouaud","Georges Conchon","Henri Barbusse","Maurice Druon"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3525: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Maurice Druon de remporter le Prix Goncourt en 1948 ?",
      answers: ["Les Grandes Familles","Pas pleurer","Le Chèvrefeuille","Le premier accroc coûte deux cents francs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3526: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Robert Merle a-t-il remporté le Prix Goncourt pour Week-end à Zuydcoote ?",
      answers: ["1954","1968","1949","1920"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3527: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1949 pour Week-end à Zuydcoote ?",
      answers: ["Jean Vautrin","Robert Merle","Paul Colin","Maurice Druon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3528: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Robert Merle de remporter le Prix Goncourt en 1949 ?",
      answers: ["Les Jeux sauvages","Un grand pas vers le Bon Dieu","Mon village à l’heure allemande","Week-end à Zuydcoote"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3529: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Paul Colin a-t-il remporté le Prix Goncourt pour Les Jeux sauvages ?",
      answers: ["1989","1950","1957","1988"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3530: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1950 pour Les Jeux sauvages ?",
      answers: ["Julien Gracq","Henri Béraud","Paul Colin","Jean Cau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3531: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Paul Colin de remporter le Prix Goncourt en 1950 ?",
      answers: ["Les Mandarins","Les Bienveillantes","Les Jeux sauvages","Léon Morin, prêtre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3532: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Julien Gracq a-t-il remporté le Prix Goncourt pour Le Rivage des Syrtes ?",
      answers: ["1980","1950","1999","1951"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3533: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1951 pour Le Rivage des Syrtes ?",
      answers: ["Yves Navarre","Paul Colin","Julien Gracq","Francis Carco"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3534: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Julien Gracq de remporter le Prix Goncourt en 1951 ?",
      answers: ["Léon Morin, prêtre","Week-end à Zuydcoote","Le Rivage des Syrtes","L’Art français de la guerre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3535: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Béatrice Beck a-t-elle remportée le Prix Goncourt pour Léon Morin, prêtre ?",
      answers: ["1934","1910","1916","1952"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3536: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1952 pour Léon Morin, prêtre ?",
      answers: ["Pierre Gascar","Jean-Louis Curtis","Jacques Chessex","Béatrice Beck"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3537: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Béatrice Beck de remporter le Prix Goncourt en 1952 ?",
      answers: ["Les Bêtes","Les Eaux mêlées","Léon Morin, prêtre","Quand la mer se retire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3538: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pierre Gascar a-t-il remporté le Prix Goncourt pour Les Bêtes ?",
      answers: ["2011","1959","1953","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3539: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1953 pour Les Bêtes ?",
      answers: ["Maurice Bedel","Pierre Gascar","Marius Grout","Maurice Genevoix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3540: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pierre Gascar de remporter le Prix Goncourt en 1953 ?",
      answers: ["Les Bêtes","Les Jeux sauvages","Pareils à des enfants","Le Rivage des Syrtes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3541: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Simone de Beauvoir a-t-elle remportée le Prix Goncourt pour Les Mandarins ?",
      answers: ["1953","1988","1954","1968"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3542: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1954 pour Les Mandarins ?",
      answers: ["Simone de Beauvoir","Didier Van Cauwelaert","Roger Vercel","André Pieyre de Mandiargues"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3543: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Simone de Beauvoir de remporter le Prix Goncourt en 1954 ?",
      answers: ["De Goupil à Margot","La Motocyclette","Les Mandarins","Pareils à des enfants"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3544: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Roger Ikor a-t-il remporté le Prix Goncourt pour Les Eaux mêlées ?",
      answers: ["1954","1952","1955","1944"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3545: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1955 pour Les Eaux mêlées ?",
      answers: ["Roger Ikor","Béatrice Beck","Michel Tournier","André Pieyre de Mandiargues"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3546: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Roger Ikor de remporter le Prix Goncourt en 1955 ?",
      answers: ["Les Bêtes","Mal d’amour","Les Eaux mêlées","Le Testament français"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3547: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Romain Gary a-t-il remporté le Prix Goncourt pour Les Racines du ciel ?",
      answers: ["1956","1998","1952","1954"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3548: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1956 pour Les Racines du ciel ?",
      answers: ["Pierre Lemaitre","Romain Gary","Jean-Jacques Schuhl","Vintila Horia"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3549: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Romain Gary de remporter le Prix Goncourt en 1956 ?",
      answers: ["Les Mandarins","Le Dernier des Justes","Week-end à Zuydcoote","Les Racines du ciel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3550: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Roger Vailland a-t-il remporté le Prix Goncourt pour La Loi ?",
      answers: ["1961","1957","1956","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3551: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1957 pour La Loi ?",
      answers: ["Vintila Horia","Roger Ikor","Roger Vailland","Romain Gary"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3552: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Roger Vailland de remporter le Prix Goncourt en 1957 ?",
      answers: ["La Loi","Mon village à l’heure allemande","Le premier accroc coûte deux cents francs","L’Ordre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3553: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Francis Carco a-t-il remporté le Prix Goncourt pour L’Homme de minuit ?",
      answers: ["1970","1974","1958","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3554: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1958 pour L’Homme de minuit ?",
      answers: ["Francis Ambrière","André Pieyre de Mandiargues","Francis Carco","Georges Conchon"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3555: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Francis Carco de remporter le Prix Goncourt en 1958 ?",
      answers: ["Le Rocher de Tanios","Quand la mer se retire","Les Mandarins","L’Homme de minuit"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3556: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Pieyre de Mandiargues a-t-il remporté le Prix Goncourt pour La Motocyclette ?",
      answers: ["1966","1959","1958","1936"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3557: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1959 pour La Motocyclette ?",
      answers: ["Pierre Lemaitre","Marcel Arland","Roger Vailland","André Pieyre de Mandiargues"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3558: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à André Pieyre de Mandiargues de remporter le Prix Goncourt en 1959 ?",
      answers: ["La Motocyclette","Les Jeux sauvages","Faux passeports","Le premier accroc coûte deux cents francs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3559: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Vintila Horia a-t-il remporté le Prix Goncourt pour Dieu est né en exil ?",
      answers: ["1945","1960","1962","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3560: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1960 pour Dieu est né en exil ?",
      answers: ["Vintila Horia","Yves Navarre","Jacques Borel","Armand Lanoux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3561: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Vintila Horia de remporter le Prix Goncourt en 1960 ?",
      answers: ["La Carte et le Territoire","Dieu est né en exil","L’Homme de minuit","Les Champs d’honneur"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3562: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Cau a-t-il remporté le Prix Goncourt pour La Pitié de Dieu ?",
      answers: ["1962","1941","1961","1984"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3563: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1961 pour La Pitié de Dieu ?",
      answers: ["Jean Cau","Armand Lanoux","Pascal Lainé","Jacques Chessex"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3564: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Cau de remporter le Prix Goncourt en 1961 ?",
      answers: ["Le Peuple de la mer","Le Testament français","La Pitié de Dieu","Faux passeports"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3565: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Schwarz-Bart a-t-il remporté le Prix Goncourt pour Le Dernier des Justes ?",
      answers: ["1963","1925","1971","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3566: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1962 pour Le Dernier des Justes ?",
      answers: ["Roger Vailland","André Schwarz-Bart","André Pieyre de Mandiargues","Lucien Bodard"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3567: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à André Schwarz-Bart de remporter le Prix Goncourt en 1962 ?",
      answers: ["Le Dernier des Justes","Un homme se penche sur son passé","L’Adoration","Le Roi des aulnes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3568: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Armand Lanoux a-t-il remporté le Prix Goncourt pour Quand la mer se retire ?",
      answers: ["1937","1963","1987","1964"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3569: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1963 pour Quand la mer se retire ?",
      answers: ["Armand Lanoux","André Schwarz-Bart","Félicien Marceau","Paul Colin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3570: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Armand Lanoux de remporter le Prix Goncourt en 1963 ?",
      answers: ["Le Jardin d’acclimatation","L’Épervier de Maheux","L’État sauvage","Quand la mer se retire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3571: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Georges Conchon a-t-il remporté le Prix Goncourt pour L’État sauvage ?",
      answers: ["1966","1994","1969","1964"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3572: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1964 pour L’État sauvage ?",
      answers: ["Elsa Triolet","Georges Conchon","Robert Merle","Henri Béraud"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3573: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Georges Conchon de remporter le Prix Goncourt en 1964 ?",
      answers: ["Pélagie-la-Charrette","L’État sauvage","Rouge Brésil","Les Mandarins"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3574: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jacques Borel a-t-il remporté le Prix Goncourt pour L’Adoration ?",
      answers: ["1963","1947","1965","1933"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3575: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1965 pour L’Adoration ?",
      answers: ["Jacques Borel","Henri Deberly","Edmonde Charles-Roux","Armand Lanoux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3576: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jacques Borel de remporter le Prix Goncourt en 1965 ?",
      answers: ["L’Adoration","Ingrid Caven","Les Loups","Dieu est né en exil"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3577: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Edmonde Charles-Roux a-t-elle remportée le Prix Goncourt pour Oublier Palerme ?",
      answers: ["1970","1954","1966","1908"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3578: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1966 pour Oublier Palerme ?",
      answers: ["Edmonde Charles-Roux","André Pieyre de Mandiargues","Béatrice Beck","Constantin-Weyer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3579: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Edmonde Charles-Roux de remporter le Prix Goncourt en 1966 ?",
      answers: ["Quand la mer se retire","Oublier Palerme","L’Araigne","L’Épervier de Maheux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3580: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année André Pieyre de Mandiargues a-t-il remporté le Prix Goncourt pour La Marge ?",
      answers: ["1963","1960","1968","1967"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3581: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1967 pour La Marge ?",
      answers: ["André Pieyre de Mandiargues","Jean-Christophe Rufin","Pascal Quignard","Brigitte Giraud"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3582: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à André Pieyre de Mandiargues de remporter le Prix Goncourt en 1967 ?",
      answers: ["L’État sauvage","La Marge","Les Fruits de l’hiver","Creezy"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3583: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Bernard Clavel a-t-il remporté le Prix Goncourt pour Les Fruits de l’hiver ?",
      answers: ["2000","1969","1968","1936"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3584: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1968 pour Les Fruits de l’hiver ?",
      answers: ["Henri Béraud","André Pieyre de Mandiargues","André Schwarz-Bart","Bernard Clavel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3585: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Bernard Clavel de remporter le Prix Goncourt en 1968 ?",
      answers: ["Le Roi des aulnes","Valet de nuit","Les Fruits de l’hiver","Creezy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3586: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Félicien Marceau a-t-il remporté le Prix Goncourt pour Creezy ?",
      answers: ["1913","1969","1981","1963"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3587: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1969 pour Creezy ?",
      answers: ["Michel Tournier","Félicien Marceau","Jean Carrière","André Pieyre de Mandiargues"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3588: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Félicien Marceau de remporter le Prix Goncourt en 1969 ?",
      answers: ["Vent de Mars","Creezy","L’Adoration","Le Jardin d’acclimatation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3589: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Michel Tournier a-t-il remporté le Prix Goncourt pour Le Roi des aulnes ?",
      answers: ["1969","1970","2011","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3590: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1970 pour Le Roi des aulnes ?",
      answers: ["Félicien Marceau","Marie NDiaye","Bernard Clavel","Michel Tournier"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3591: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Michel Tournier de remporter le Prix Goncourt en 1970 ?",
      answers: ["La Bataille","Le Roi des aulnes","La Marge","Le Jardin d’acclimatation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3592: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jacques Laurent a-t-il remporté le Prix Goncourt pour Les Bêtises ?",
      answers: ["1970","1971","1985","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3593: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1971 pour Les Bêtises ?",
      answers: ["Émile Ajar (Romain Gary)","Jacques Laurent","Jean Carrière","André Pieyre de Mandiargues"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3594: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jacques Laurent de remporter le Prix Goncourt en 1971 ?",
      answers: ["Passage de l’homme","Les Bêtises","La Maternelle","Le Jardin d’acclimatation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3595: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Carrière a-t-il remporté le Prix Goncourt pour L’Épervier de Maheux ?",
      answers: ["1956","2018","1993","1972"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3596: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1972 pour L’Épervier de Maheux ?",
      answers: ["Jean Carrière","Patrick Grainville","Jean-Christophe Rufin","Pierre Gascar"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3597: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Carrière de remporter le Prix Goncourt en 1972 ?",
      answers: ["La Dentellière","Dieu est né en exil","Les Noces barbares","L’Épervier de Maheux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3598: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jacques Chessex a-t-il remporté le Prix Goncourt pour L’Ogre ?",
      answers: ["1995","1976","1973","1925"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3599: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1973 pour L’Ogre ?",
      answers: ["Didier Decoin","Jacques Chessex","Dominique Fernandez","Georges Conchon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3600: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jacques Chessex de remporter le Prix Goncourt en 1973 ?",
      answers: ["La Vie devant soi","L’Ogre","Le premier accroc coûte deux cents francs","L’Épervier de Maheux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3601: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pascal Lainé a-t-il remporté le Prix Goncourt pour La Dentellière ?",
      answers: ["1976","1984","1974","1991"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3602: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1974 pour La Dentellière ?",
      answers: ["Émile Ajar (Romain Gary)","Didier Decoin","Pascal Lainé","Yves Navarre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3603: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pascal Lainé de remporter le Prix Goncourt en 1974 ?",
      answers: ["Les Enfants gâtés","La Vie devant soi","Creezy","La Dentellière"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3604: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Émile Ajar (Romain Gary) a-t-il remporté le Prix Goncourt pour La Vie devant soi ?",
      answers: ["1955","1975","1932","1977"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3605: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1975 pour La Vie devant soi ?",
      answers: ["Michel Tournier","Émile Ajar (Romain Gary)","Tahar Ben Jelloun","Pascal Lainé"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3606: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Émile Ajar (Romain Gary) de remporter le Prix Goncourt en 1975 ?",
      answers: ["L’Épervier de Maheux","Pélagie-la-Charrette","La Vie devant soi","Creezy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3607: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Patrick Grainville a-t-il remporté le Prix Goncourt pour Les Flamboyants ?",
      answers: ["1976","1974","1977","1975"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3608: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1976 pour Les Flamboyants ?",
      answers: ["Elsa Triolet","Alphonse de Châteaubriant","Émile Ajar (Romain Gary)","Patrick Grainville"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3609: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Patrick Grainville de remporter le Prix Goncourt en 1976 ?",
      answers: ["Les Bêtises","Les Flamboyants","Les Noces barbares","Le Sermon sur la chute de Rome"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3610: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Didier Decoin a-t-il remporté le Prix Goncourt pour John l’Enfer ?",
      answers: ["1993","1977","1996","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3611: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1977 pour John l’Enfer ?",
      answers: ["Romain Gary","Didier Decoin","Émile Moselly","Marc Bernard"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3612: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Didier Decoin de remporter le Prix Goncourt en 1977 ?",
      answers: ["L’Adoration","Un aller simple","John l’Enfer","La Dentellière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3613: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Patrick Modiano a-t-il remporté le Prix Goncourt pour Rue des Boutiques Obscures ?",
      answers: ["1977","1996","1978","1967"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3614: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1978 pour Rue des Boutiques Obscures ?",
      answers: ["Michel Houellebecq","Érik Orsenna","Patrick Modiano","Émile Ajar (Romain Gary)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3615: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Patrick Modiano de remporter le Prix Goncourt en 1978 ?",
      answers: ["Les Égarés","Les Champs d’honneur","Rue des Boutiques Obscures","Un aller simple"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3616: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Antonine Maillet a-t-elle remportée le Prix Goncourt pour Pélagie-la-Charrette ?",
      answers: ["1979","1981","1925","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3617: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1979 pour Pélagie-la-Charrette ?",
      answers: ["Didier Decoin","Lucien Bodard","Antonine Maillet","Kamel Daoud"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3618: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Antonine Maillet de remporter le Prix Goncourt en 1979 ?",
      answers: ["Pélagie-la-Charrette","Rue des Boutiques Obscures","Les Fruits de l’hiver","Sang et Lumières"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3619: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Yves Navarre a-t-il remporté le Prix Goncourt pour Le Jardin d’acclimatation ?",
      answers: ["1953","1980","1987","1910"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3620: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1980 pour Le Jardin d’acclimatation ?",
      answers: ["Armand Lanoux","Yves Navarre","John-Antoine Nau","Georges Conchon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3621: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Yves Navarre de remporter le Prix Goncourt en 1980 ?",
      answers: ["Dans la main de l’ange","Le Jardin d’acclimatation","Le Roi des aulnes","John l’Enfer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3622: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Lucien Bodard a-t-il remporté le Prix Goncourt pour Anne Marie ?",
      answers: ["1974","1981","1964","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3623: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1981 pour Anne Marie ?",
      answers: ["Atiq Rahimi","Patrick Grainville","Émile Ajar (Romain Gary)","Lucien Bodard"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3624: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Lucien Bodard de remporter le Prix Goncourt en 1981 ?",
      answers: ["Anne Marie","Les Bêtes","Veiller sur elle","Syngué sabour. Pierre de patience"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3625: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Dominique Fernandez a-t-il remporté le Prix Goncourt pour Dans la main de l’ange ?",
      answers: ["1994","1982","1941","2001"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3626: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1982 pour Dans la main de l’ange ?",
      answers: ["Dominique Fernandez","Frédéric Tristan","Yves Navarre","Lucien Bodard"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3627: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Dominique Fernandez de remporter le Prix Goncourt en 1982 ?",
      answers: ["Anne Marie","La Marge","Leurs enfants après eux","Dans la main de l’ange"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3628: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Frédéric Tristan a-t-il remporté le Prix Goncourt pour Les Égarés ?",
      answers: ["2018","1971","2012","1983"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3629: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1983 pour Les Égarés ?",
      answers: ["Frédéric Tristan","Pascal Quignard","Tahar Ben Jelloun","André Pieyre de Mandiargues"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3630: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Frédéric Tristan de remporter le Prix Goncourt en 1983 ?",
      answers: ["Les Égarés","Houris","L’Amant","Les Champs d’honneur"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3631: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marguerite Duras a-t-elle remportée le Prix Goncourt pour L’Amant ?",
      answers: ["1984","1919","2001","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3632: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1984 pour L’Amant ?",
      answers: ["Yann Queffélec","Marguerite Duras","Jean Echenoz","Patrick Modiano"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3633: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marguerite Duras de remporter le Prix Goncourt en 1984 ?",
      answers: ["L’Amant","Vent de Mars","Les Loups","Raboliot"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3634: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Yann Queffélec a-t-il remporté le Prix Goncourt pour Les Noces barbares ?",
      answers: ["1981","1985","1974","2001"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3635: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1985 pour Les Noces barbares ?",
      answers: ["Amin Maalouf","Jacques Chessex","Tahar Ben Jelloun","Yann Queffélec"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3636: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Yann Queffélec de remporter le Prix Goncourt en 1985 ?",
      answers: ["Les Champs d’honneur","Un aller simple","Les Noces barbares","Les Eaux mêlées"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3637: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Michel Host a-t-il remporté le Prix Goncourt pour Valet de nuit ?",
      answers: ["1992","1986","2020","2021"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3638: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1986 pour Valet de nuit ?",
      answers: ["Jean-Jacques Schuhl","Maurice Druon","Yann Queffélec","Michel Host"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3639: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Michel Host de remporter le Prix Goncourt en 1986 ?",
      answers: ["Les Eaux mêlées","Pélagie-la-Charrette","Valet de nuit","Malaisie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3640: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Tahar Ben Jelloun a-t-il remporté le Prix Goncourt pour La Nuit sacrée ?",
      answers: ["2014","1985","1996","1987"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3641: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1987 pour La Nuit sacrée ?",
      answers: ["Romain Gary","Didier Decoin","Tahar Ben Jelloun","Yann Queffélec"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3642: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Tahar Ben Jelloun de remporter le Prix Goncourt en 1987 ?",
      answers: ["Valet de nuit","Les Loups","La Motocyclette","La Nuit sacrée"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3643: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Érik Orsenna a-t-il remporté le Prix Goncourt pour L’Exposition coloniale ?",
      answers: ["1977","1988","1992","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3644: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1988 pour L’Exposition coloniale ?",
      answers: ["Tahar Ben Jelloun","Érik Orsenna","Yann Queffélec","Pierre Combescot"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3645: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Érik Orsenna de remporter le Prix Goncourt en 1988 ?",
      answers: ["Les Filles du Calvaire","L’Exposition coloniale","Le Rocher de Tanios","Chasseur zéro"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3646: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Vautrin a-t-il remporté le Prix Goncourt pour Un grand pas vers le Bon Dieu ?",
      answers: ["1988","1989","1992","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3647: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1989 pour Un grand pas vers le Bon Dieu ?",
      answers: ["Érik Orsenna","Jean Vautrin","Tahar Ben Jelloun","Amin Maalouf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3648: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Vautrin de remporter le Prix Goncourt en 1989 ?",
      answers: ["Vent de Mars","Un grand pas vers le Bon Dieu","L’Exposition coloniale","Filles de la pluie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3649: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Rouaud a-t-il remporté le Prix Goncourt pour Les Champs d’honneur ?",
      answers: ["1996","1986","2007","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3650: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1990 pour Les Champs d’honneur ?",
      answers: ["Marguerite Duras","Jean Rouaud","Pascale Roze","Léon Frapié"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3651: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Rouaud de remporter le Prix Goncourt en 1990 ?",
      answers: ["Chasseur zéro","Texaco","Le Rocher de Tanios","Les Champs d’honneur"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3652: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pierre Combescot a-t-il remporté le Prix Goncourt pour Les Filles du Calvaire ?",
      answers: ["1993","1984","1991","1988"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3653: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1991 pour Les Filles du Calvaire ?",
      answers: ["Pierre Combescot","Tahar Ben Jelloun","Antonine Maillet","Jean-Louis Curtis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3654: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pierre Combescot de remporter le Prix Goncourt en 1991 ?",
      answers: ["Les Filles du Calvaire","Les Loups","Valet de nuit","Je m’en vais"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3655: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Patrick Chamoiseau a-t-il remporté le Prix Goncourt pour Texaco ?",
      answers: ["1998","1996","1920","1992"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3656: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1992 pour Texaco ?",
      answers: ["Jacques-Pierre Amette","Jacques Borel","Pascal Quignard","Patrick Chamoiseau"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3657: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Patrick Chamoiseau de remporter le Prix Goncourt en 1992 ?",
      answers: ["Au revoir là-haut","Creezy","Texaco","L’Exposition coloniale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3658: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Amin Maalouf a-t-il remporté le Prix Goncourt pour Le Rocher de Tanios ?",
      answers: ["1975","1993","1994","1992"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3659: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1993 pour Le Rocher de Tanios ?",
      answers: ["Brigitte Giraud","Amin Maalouf","Andreï Makine","Patrick Modiano"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3660: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Amin Maalouf de remporter le Prix Goncourt en 1993 ?",
      answers: ["Anne Marie","Un grand pas vers le Bon Dieu","Le Rocher de Tanios","Le Testament français"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3661: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Didier Van Cauwelaert a-t-il remporté le Prix Goncourt pour Un aller simple ?",
      answers: ["1994","1979","2023","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3662: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1994 pour Un aller simple ?",
      answers: ["Didier Van Cauwelaert","Jean Rouaud","Andreï Makine","Pascale Roze"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3663: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Didier Van Cauwelaert de remporter le Prix Goncourt en 1994 ?",
      answers: ["Le Feu","Un aller simple","Les Champs d’honneur","L’Adoration"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3664: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Andreï Makine a-t-il remporté le Prix Goncourt pour Le Testament français ?",
      answers: ["1938","1995","1982","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3665: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1995 pour Le Testament français ?",
      answers: ["Andreï Makine","Pascal Lainé","Laurent Gaudé","Jean Echenoz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3666: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Andreï Makine de remporter le Prix Goncourt en 1995 ?",
      answers: ["Le Testament français","Texaco","Confidence pour confidence","Chasseur zéro"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3667: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pascale Roze a-t-elle remportée le Prix Goncourt pour Chasseur zéro ?",
      answers: ["1996","2012","1995","2001"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3668: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1996 pour Chasseur zéro ?",
      answers: ["Pascale Roze","Patrick Rambaud","Jean Echenoz","Félicien Marceau"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3669: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pascale Roze de remporter le Prix Goncourt en 1996 ?",
      answers: ["Chasseur zéro","Les Égarés","Les Filles du Calvaire","Je m’en vais"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3670: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Patrick Rambaud a-t-il remporté le Prix Goncourt pour La Bataille ?",
      answers: ["1997","1998","1996","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3671: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1997 pour La Bataille ?",
      answers: ["Amin Maalouf","Jean-Jacques Schuhl","Patrick Rambaud","Félicien Marceau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3672: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Patrick Rambaud de remporter le Prix Goncourt en 1997 ?",
      answers: ["La Bataille","L’Art français de la guerre","Les Forêts de la nuit","Un aller simple"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3673: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Paule Constant a-t-elle remportée le Prix Goncourt pour Confidence pour confidence ?",
      answers: ["2021","2005","1998","1990"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3674: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1998 pour Confidence pour confidence ?",
      answers: ["Jean Echenoz","Paule Constant","Andreï Makine","Leïla Slimani"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3675: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Paule Constant de remporter le Prix Goncourt en 1998 ?",
      answers: ["Chasseur zéro","Le Testament français","Confidence pour confidence","Les Champs d’honneur"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3676: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean Echenoz a-t-il remporté le Prix Goncourt pour Je m’en vais ?",
      answers: ["1999","1987","1986","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3677: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 1999 pour Je m’en vais ?",
      answers: ["Didier Van Cauwelaert","Patrick Chamoiseau","Jacques Chessex","Jean Echenoz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3678: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean Echenoz de remporter le Prix Goncourt en 1999 ?",
      answers: ["Je m’en vais","Les Bêtes","La Maîtresse de Brecht","Au revoir là-haut"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3679: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Jacques Schuhl a-t-il remporté le Prix Goncourt pour Ingrid Caven ?",
      answers: ["2012","2001","1967","2000"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3680: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2000 pour Ingrid Caven ?",
      answers: ["Jean-Jacques Gautier","Charles Plisnier","Jean-Christophe Rufin","Jean-Jacques Schuhl"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3681: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Jacques Schuhl de remporter le Prix Goncourt en 2000 ?",
      answers: ["Texaco","Ingrid Caven","Le Jardin d’acclimatation","Chasseur zéro"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3682: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Christophe Rufin a-t-il remporté le Prix Goncourt pour Rouge Brésil ?",
      answers: ["2001","2002","2005","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3683: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2001 pour Rouge Brésil ?",
      answers: ["Jérôme Ferrari","Jean-Christophe Rufin","Patrick Rambaud","Didier Van Cauwelaert"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3684: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Christophe Rufin de remporter le Prix Goncourt en 2001 ?",
      answers: ["Texaco","Pas pleurer","Ingrid Caven","Rouge Brésil"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3685: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pascal Quignard a-t-il remporté le Prix Goncourt pour Les Ombres errantes ?",
      answers: ["2002","2000","2003","1999"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3686: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2002 pour Les Ombres errantes ?",
      answers: ["Pascal Quignard","Jean-Paul Dubois","Yann Queffélec","Atiq Rahimi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3687: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pascal Quignard de remporter le Prix Goncourt en 2002 ?",
      answers: ["Les Forêts de la nuit","Les Ombres errantes","Le Rocher de Tanios","Trois jours chez ma mère"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3688: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jacques-Pierre Amette a-t-il remporté le Prix Goncourt pour La Maîtresse de Brecht ?",
      answers: ["2003","2002","1959","1972"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3689: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2003 pour La Maîtresse de Brecht ?",
      answers: ["Leïla Slimani","Jacques-Pierre Amette","Didier Decoin","Kamel Daoud"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3690: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jacques-Pierre Amette de remporter le Prix Goncourt en 2003 ?",
      answers: ["Les Eaux mêlées","Le Rocher de Tanios","La Maîtresse de Brecht","Le Soleil des Scorta"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3691: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Laurent Gaudé a-t-il remporté le Prix Goncourt pour Le Soleil des Scorta ?",
      answers: ["2002","2004","2005","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3692: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2004 pour Le Soleil des Scorta ?",
      answers: ["Gilles Leroy","Laurent Gaudé","Marie NDiaye","Michel Houellebecq"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3693: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Laurent Gaudé de remporter le Prix Goncourt en 2004 ?",
      answers: ["Ingrid Caven","Un aller simple","Syngué sabour. Pierre de patience","Le Soleil des Scorta"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3694: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année François Weyergans a-t-il remporté le Prix Goncourt pour Trois jours chez ma mère ?",
      answers: ["2007","2005","1979","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3695: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2005 pour Trois jours chez ma mère ?",
      answers: ["Jonathan Littell","François Weyergans","Jean-Christophe Rufin","Pascal Quignard"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3696: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à François Weyergans de remporter le Prix Goncourt en 2005 ?",
      answers: ["Ingrid Caven","La Maîtresse de Brecht","Veiller sur elle","Trois jours chez ma mère"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3697: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jonathan Littell a-t-il remporté le Prix Goncourt pour Les Bienveillantes ?",
      answers: ["2022","2005","2008","2006"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3698: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2006 pour Les Bienveillantes ?",
      answers: ["Laurent Gaudé","Jacques-Pierre Amette","Amin Maalouf","Jonathan Littell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3699: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jonathan Littell de remporter le Prix Goncourt en 2006 ?",
      answers: ["Le Soleil des Scorta","La Maîtresse de Brecht","Les Bienveillantes","Pas pleurer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3700: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Gilles Leroy a-t-il remporté le Prix Goncourt pour Alabama Song ?",
      answers: ["2003","2009","2007","1971"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3701: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2007 pour Alabama Song ?",
      answers: ["Lydie Salvayre","Gilles Leroy","Michel Houellebecq","Jonathan Littell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3702: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Gilles Leroy de remporter le Prix Goncourt en 2007 ?",
      answers: ["Les Bienveillantes","Alabama Song","Trois jours chez ma mère","Un aller simple"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3703: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Atiq Rahimi a-t-il remporté le Prix Goncourt pour Syngué sabour. Pierre de patience ?",
      answers: ["2008","2012","2005","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3704: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2008 pour Syngué sabour. Pierre de patience ?",
      answers: ["Pascale Roze","Atiq Rahimi","Alexis Jenni","Jean-Christophe Rufin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3705: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Atiq Rahimi de remporter le Prix Goncourt en 2008 ?",
      answers: ["Trois jours chez ma mère","Au revoir là-haut","Le Sermon sur la chute de Rome","Syngué sabour. Pierre de patience"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3706: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Marie NDiaye a-t-elle remportée le Prix Goncourt pour Trois femmes puissantes ?",
      answers: ["2008","2009","2005","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3707: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2009 pour Trois femmes puissantes ?",
      answers: ["Hervé Le Tellier","Marie NDiaye","Pierre Lemaitre","Jean Rouaud"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3708: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Marie NDiaye de remporter le Prix Goncourt en 2009 ?",
      answers: ["Trois femmes puissantes","Sang et Lumières","L’Ogre","Les Bienveillantes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3709: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Michel Houellebecq a-t-il remporté le Prix Goncourt pour La Carte et le Territoire ?",
      answers: ["2010","2008","1980","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3710: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2010 pour La Carte et le Territoire ?",
      answers: ["Pierre Lemaitre","Jérôme Ferrari","Alexis Jenni","Michel Houellebecq"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3711: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Michel Houellebecq de remporter le Prix Goncourt en 2010 ?",
      answers: ["Alabama Song","Le Roi des aulnes","Rabevel ou le Mal des ardents","La Carte et le Territoire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3712: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Alexis Jenni a-t-il remporté le Prix Goncourt pour L’Art français de la guerre ?",
      answers: ["1968","1975","2013","2011"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3713: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2011 pour L’Art français de la guerre ?",
      answers: ["Alexis Jenni","Pierre Lemaitre","Pascal Quignard","Gilles Leroy"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3714: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Alexis Jenni de remporter le Prix Goncourt en 2011 ?",
      answers: ["Le Sermon sur la chute de Rome","L’Art français de la guerre","La Carte et le Territoire","Pélagie-la-Charrette"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3715: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jérôme Ferrari a-t-il remporté le Prix Goncourt pour Le Sermon sur la chute de Rome ?",
      answers: ["2004","1989","2007","2012"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3716: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2012 pour Le Sermon sur la chute de Rome ?",
      answers: ["Paule Constant","Jérôme Ferrari","Laurent Gaudé","Félicien Marceau"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3717: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jérôme Ferrari de remporter le Prix Goncourt en 2012 ?",
      answers: ["La Nuit sacrée","Boussole","Le Sermon sur la chute de Rome","Pas pleurer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3718: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Pierre Lemaitre a-t-il remporté le Prix Goncourt pour Au revoir là-haut ?",
      answers: ["2022","2013","2017","1963"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3719: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2013 pour Au revoir là-haut ?",
      answers: ["Lydie Salvayre","Alexis Jenni","Pierre Lemaitre","Marie NDiaye"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3720: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Pierre Lemaitre de remporter le Prix Goncourt en 2013 ?",
      answers: ["L’Amant","Alabama Song","Les Bêtes","Au revoir là-haut"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3721: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Lydie Salvayre a-t-elle remportée le Prix Goncourt pour Pas pleurer ?",
      answers: ["2014","2012","2015","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3722: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2014 pour Pas pleurer ?",
      answers: ["Nicolas Mathieu","Patrick Grainville","Lydie Salvayre","Jérôme Ferrari"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3723: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Lydie Salvayre de remporter le Prix Goncourt en 2014 ?",
      answers: ["Leurs enfants après eux","Veiller sur elle","La Maîtresse de Brecht","Pas pleurer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3724: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Mathias Énard a-t-il remporté le Prix Goncourt pour Boussole ?",
      answers: ["2014","1989","1993","2015"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3725: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2015 pour Boussole ?",
      answers: ["Atiq Rahimi","Gilles Leroy","Edmonde Charles-Roux","Mathias Énard"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3726: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Mathias Énard de remporter le Prix Goncourt en 2015 ?",
      answers: ["Boussole","La Plus Secrète Mémoire des hommes","Rabevel ou le Mal des ardents","Faux passeports"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3727: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Leïla Slimani a-t-elle remportée le Prix Goncourt pour Chanson douce ?",
      answers: ["2016","2012","1998","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3728: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2016 pour Chanson douce ?",
      answers: ["Leïla Slimani","Jean-Paul Dubois","Pierre Combescot","Patrick Rambaud"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3729: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Leïla Slimani de remporter le Prix Goncourt en 2016 ?",
      answers: ["L’Art français de la guerre","Trois jours chez ma mère","Chanson douce","Les Jeux sauvages"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3730: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Éric Vuillard a-t-il remporté le Prix Goncourt pour L’Ordre du jour ?",
      answers: ["2015","2017","2016","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3731: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2017 pour L’Ordre du jour ?",
      answers: ["Leïla Slimani","Gilles Leroy","Hervé Le Tellier","Éric Vuillard"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3732: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Éric Vuillard de remporter le Prix Goncourt en 2017 ?",
      answers: ["Terres lorraines","Veiller sur elle","L’Anomalie","L’Ordre du jour"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3733: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Nicolas Mathieu a-t-il remporté le Prix Goncourt pour Leurs enfants après eux ?",
      answers: ["2009","1986","2018","1998"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3734: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2018 pour Leurs enfants après eux ?",
      answers: ["Jérôme Ferrari","Antonine Maillet","Jean-Jacques Gautier","Nicolas Mathieu"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3735: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Nicolas Mathieu de remporter le Prix Goncourt en 2018 ?",
      answers: ["Chanson douce","Leurs enfants après eux","L’Ordre du jour","Boussole"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3736: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Paul Dubois a-t-il remporté le Prix Goncourt pour Tous les hommes n’habitent pas le monde de la même façon ?",
      answers: ["2016","1994","2017","2019"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3737: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2019 pour Tous les hommes n’habitent pas le monde de la même façon ?",
      answers: ["Jean-Baptiste Andrea","Hervé Le Tellier","Jean-Paul Dubois","Leïla Slimani"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3738: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Paul Dubois de remporter le Prix Goncourt en 2019 ?",
      answers: ["Tous les hommes n’habitent pas le monde de la même façon","Au revoir là-haut","Vivre vite","L’Anomalie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3739: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Hervé Le Tellier a-t-il remporté le Prix Goncourt pour L’Anomalie ?",
      answers: ["1975","2022","2002","2020"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3740: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2020 pour L’Anomalie ?",
      answers: ["Gilles Leroy","Hervé Le Tellier","Patrick Grainville","Jean-Paul Dubois"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3741: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Hervé Le Tellier de remporter le Prix Goncourt en 2020 ?",
      answers: ["Tous les hommes n’habitent pas le monde de la même façon","L’Anomalie","Trois jours chez ma mère","Vivre vite"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3742: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Mohamed Mbougar Sarr a-t-il remporté le Prix Goncourt pour La Plus Secrète Mémoire des hommes ?",
      answers: ["2017","1981","2023","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3743: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2021 pour La Plus Secrète Mémoire des hommes ?",
      answers: ["Mohamed Mbougar Sarr","Hervé Le Tellier","Leïla Slimani","Pierre Lemaitre"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3744: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Mohamed Mbougar Sarr de remporter le Prix Goncourt en 2021 ?",
      answers: ["La Marge","Le Sermon sur la chute de Rome","La Pitié de Dieu","La Plus Secrète Mémoire des hommes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3745: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Brigitte Giraud a-t-elle remportée le Prix Goncourt pour Vivre vite ?",
      answers: ["1951","2016","2022","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3746: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2022 pour Vivre vite ?",
      answers: ["Jean-Christophe Rufin","Brigitte Giraud","Hervé Le Tellier","Marie NDiaye"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3747: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Brigitte Giraud de remporter le Prix Goncourt en 2022 ?",
      answers: ["La Plus Secrète Mémoire des hommes","L’Ordre du jour","Veiller sur elle","Vivre vite"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3748: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Jean-Baptiste Andrea a-t-il remporté le Prix Goncourt pour Veiller sur elle ?",
      answers: ["2018","2023","2021","2024"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id3749: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2023 pour Veiller sur elle ?",
      answers: ["Éric Vuillard","Amin Maalouf","Jean-Baptiste Andrea","Brigitte Giraud"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id3750: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Jean-Baptiste Andrea de remporter le Prix Goncourt en 2023 ?",
      answers: ["La Plus Secrète Mémoire des hommes","La Loi","Houris","Veiller sur elle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3751: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "En quelle année Kamel Daoud a-t-il remporté le Prix Goncourt pour Houris ?",
      answers: ["2024","2015","1945","1982"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id3752: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel(le) auteur a remporté le Prix Goncourt en 2024 pour Houris ?",
      answers: ["Jonathan Littell","Brigitte Giraud","Jean-Baptiste Andrea","Kamel Daoud"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id3753: {
      themes: ["Prix Goncourt","Littérature et Langues","Littérature","Divers"],
      question: "Quel livre a permis à Kamel Daoud de remporter le Prix Goncourt en 2024 ?",
      answers: ["Veiller sur elle","Houris","Vivre vite","Leurs enfants après eux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
  };
  export default dataLiterature;
//  module.exports = dataLiterature;